<template>
	<div class="h-chat">
		<div class="h-header" :style="{'background-color':page.color}" style="display: flex;">
			<!-- <div class="title">
				<span class="ic-chat" ><img style="width: 24px;" src="https://omnisales.worldfone.vn/portal/assets/images/livechat/icon-white-64x64.png" alt=""></span>
				<h1 class="list-title">{{page.title_ready_text}}</h1>
				<p class="list-desc">{{page.title_agentname_text}}</p>
			</div>
			<div class="head-action">
				<i class="fas fa-cog" v-on:click="toggle_widget_setting"></i>
				<i class="fas fa-times" v-on:click="minimize"></i>
				<ul class="widget-setting-dropdown">
				<li><i class="fas fa-volume-down widget-setting-icon"></i> {{$t('sound')}} <label class="switch"><input type="checkbox" v-model="setting_sound"> <div class="circle round"></div></label></li>
				<li><i class="fas fa-bell widget-setting-icon"></i> {{$t('notification')}} <label class="switch"><input type="checkbox" v-model="setting_noti"> <div class="circle round"></div></label></li>
				<li v-on:click="reload_iframe"><i class="fas fa-power-off widget-setting-icon"></i> {{$t('resolve')}}</li>
				</ul>
			</div> -->
			<div class="logo text-center" v-if="page.logo">
				<img :src="page.logo" :title="page.title_survey_heading">
			</div>
			<div class="h-header-top " style="    display: block;width: 100%;">
				<div class="h-header-top-out">
					<div class="widget-header--top-wrapper">
						<div class="widget-header-title">
							<!-- {{page.title_ready_text}}  -->{{$t('title_ready_text')}}
						</div>
						<div class="head-action">
							<!-- <i class="fas fa-cog"></i> -->
							<i class="fas fa-ellipsis-v menu_resolve" v-if="!isHideSolvedButton" v-on:click="toggle_widget_setting"></i>
							<i class="fas fa-times" v-on:click="minimize"></i>
							<ul class="widget-setting-dropdown">
								<!-- <li><i class="fas fa-volume-down widget-setting-icon"></i> {{$t('sound')}} <label class="switch"><input type="checkbox" v-model="setting_sound"> <div class="circle round"></div></label></li>  -->
								<!-- <li><i class="fas fa-bell widget-setting-icon"></i> {{$t('notification')}} <label class="switch"><input type="checkbox" v-model="setting_noti"> <div class="circle round"></div></label></li> -->
								<!-- <li><i class="fa fa-language widget-setting-icon"></i> {{$t('language')}}
								<select id="select_lang" v-model="lang" style="float: right; color:#888; margin-right: 11px;" @change="setLang($event)">
									<option value="vi" >Việt Nam</option>
									<option value="en" >English</option>
								</select>
								</li> -->
								<!-- <li v-on:click="download_msg_txt()"><i class="fas fa-download widget-setting-icon"></i> {{$t('download_message')}}</li> -->
								<li v-on:click="reload_iframe();reload_iframe_click=1" v-if="reload_iframe_click==0"
									data-id="111"><i class="fas fa-power-off widget-setting-icon"></i>
									{{$t('resolve')}}</li>
								<li v-else data-id="222"><i class="fas fa-power-off widget-setting-icon"></i>
									{{$t('resolve')}}</li>
							</ul>
						</div>
					</div>
					<div class="wrap-header-middle" style="display: block">
						<!-- <div class="agent-img" v-if="page.logo">
							<img :src="page.logo" :title="page.title_survey_heading">
						</div> -->

						<div v-if="page.title_agentname_text" class="title">
							<p class="list-desc"> {{$t('title_agentname_text')}}
							</p>
						</div>
					</div>
					<div class="social-logo" v-if="page.socials_chat">
						<div class="inner-social-logo" style="margin: 0;">
							<div v-if="page.socials_chat && page.socials_chat.phone">
								<a :href="'tel:'+page.socials_chat.phone">
									<img class="phone-logo"
										src="https://omnisales.worldfone.vn/portal/assets/images/icon/phone.svg" alt="">
								</a>
							</div>
							<div v-if="page.socials_chat && page.socials_chat.facebook ">
								<a :href="page.socials_chat.facebook" target="_blank">
									<img class="fb-logo"
										src="data:image/svg+xml,%3C?xml%20version%3D%221.0%22%20?%3E%3Csvg%20width%3D%2230%22%20height%3D%2230%22%20viewBox%3D%220%200%2030%2030%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Crect%20width%3D%2230%22%20height%3D%2230%22%20rx%3D%2215%22%20fill%3D%22%23007FFF%22/%3E%3Crect%20x%3D%224.28564%22%20y%3D%226%22%20width%3D%2221.4286%22%20height%3D%2218.8571%22%20fill%3D%22white%22/%3E%3Cpath%20d%3D%22M14.9478%2014.5713C14.8228%2014.5917%2014.6974%2014.6104%2014.5715%2014.6276C14.6974%2014.6104%2014.8228%2014.5917%2014.9478%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.7507%2014.5713C14.691%2014.5823%2014.6313%2014.5923%2014.5715%2014.6026C14.6313%2014.5923%2014.691%2014.5823%2014.7507%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M15.0126%2014.5713C14.8663%2014.5878%2014.7192%2014.6024%2014.5715%2014.6148C14.7192%2014.6024%2014.8663%2014.5878%2015.0126%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.783%2014.5713C14.7128%2014.5807%2014.642%2014.5894%2014.5715%2014.5976C14.642%2014.5894%2014.7128%2014.5807%2014.783%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.7299%2014.5713C14.6773%2014.5825%2014.6244%2014.5937%2014.5715%2014.6045C14.6244%2014.5937%2014.6773%2014.5825%2014.7299%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.6992%2014.5713C14.6567%2014.5834%2014.6141%2014.5949%2014.5715%2014.6068C14.6141%2014.5949%2014.6567%2014.5834%2014.6992%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.7107%2014.5713C14.6645%2014.5834%2014.618%2014.5958%2014.5715%2014.6075C14.618%2014.5958%2014.6645%2014.5836%2014.7107%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.7194%2014.5713C14.6704%2014.5827%2014.621%2014.5935%2014.5715%2014.6045C14.621%2014.5935%2014.6704%2014.5827%2014.7194%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.8087%2014.5713C14.7297%2014.5779%2014.6507%2014.5839%2014.5715%2014.5891C14.6507%2014.5839%2014.7297%2014.5779%2014.8087%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M15.0417%2014.5713C14.8856%2014.5814%2014.7288%2014.5894%2014.5715%2014.5946C14.7288%2014.5894%2014.8856%2014.5814%2015.0417%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.8206%2014.5713C14.7377%2014.574%2014.6546%2014.5761%2014.5715%2014.5775C14.6546%2014.5761%2014.7377%2014.574%2014.8206%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.1547%2012.3174L9.29419%2017.4636L13.7176%2015.0365L16.0288%2017.4636L20.8621%2012.3174L16.4877%2014.7019L14.1547%2012.3174Z%22%20fill%3D%22%23448AFF%22/%3E%3Cpath%20d%3D%22M15%200C6.717%200%200%206.717%200%2015C0%2023.283%206.717%2030%2015%2030C23.283%2030%2030%2023.283%2030%2015C30%206.717%2023.283%200%2015%200ZM15.1172%2023.0294C14.1886%2023.0294%2013.2923%2022.8983%2012.4491%2022.6554L9.42421%2024.375V21.14C7.39815%2019.5982%206.10428%2017.2501%206.10428%2014.6203C6.10428%209.97581%2010.1395%206.21094%2015.1172%206.21094C20.0951%206.21094%2024.1301%209.97581%2024.1301%2014.6203C24.1301%2019.2643%2020.0951%2023.0294%2015.1172%2023.0294V23.0294Z%22%20fill%3D%22%23007FFF%22/%3E%3C/svg%3E"
										alt="">
								</a>
							</div>
							<div v-if="page.socials_chat && page.socials_chat.zalo ">
								<a :href="page.socials_chat.zalo" target="_blank">
									<img class="fb-logo"
										src="data:image/svg+xml,%3C?xml%20version%3D%221.0%22%20?%3E%3Csvg%20width%3D%2230%22%20height%3D%2230%22%20viewBox%3D%220%200%2030%2030%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M29.9999%2014.9385C29.9669%206.68262%2023.2639%200%2015%200C6.7157%200%200%206.71582%200%2015C0%2023.2842%206.7157%2030%2015%2030C23.2639%2030%2029.9669%2023.3174%2029.9999%2015.0615C29.9999%2015.041%2030%2015.0205%2030%2015C30%2014.9795%2029.9999%2014.959%2029.9999%2014.9385Z%22%20fill%3D%22white%22/%3E%3Cpath%20d%3D%22M24.5612%2017.4695C22.9394%2017.4726%2021.6242%2016.1862%2021.6279%2014.6005C21.6316%2013.0345%2022.9474%2011.7445%2024.5473%2011.7383C26.1556%2011.732%2027.4826%2013.0349%2027.4786%2014.6162C27.4746%2016.1926%2026.1719%2017.4665%2024.5612%2017.4695ZM22.8416%2014.6183C22.8459%2015.5573%2023.6166%2016.3004%2024.5777%2016.2923C25.5165%2016.2845%2026.2699%2015.5301%2026.2673%2014.6005C26.2646%2013.6712%2025.51%2012.9317%2024.56%2012.9277C23.6012%2012.9237%2022.8373%2013.6751%2022.8416%2014.6183Z%22%20fill%3D%22%230068FE%22/%3E%3Cpath%20d%3D%22M19.5054%2010.0762H20.795V17.4217H19.9447C19.7021%2017.4217%2019.5054%2017.225%2019.5054%2016.9823V10.0762Z%22%20fill%3D%22%230068FE%22/%3E%3Cpath%20d%3D%22M18.5227%2011.8907H17.2881V12.2935C16.5767%2011.8601%2015.8509%2011.6775%2015.06%2011.831C14.2526%2011.9876%2013.6164%2012.4043%2013.167%2013.0917C12.4538%2014.1826%2012.5894%2015.5904%2013.4938%2016.5431C14.3504%2017.4454%2015.8628%2017.8178%2017.2815%2016.9247C17.2835%2016.934%2017.286%2016.9422%2017.2881%2016.9511V16.9826C17.2881%2017.2252%2017.4849%2017.422%2017.7275%2017.422H18.5227V11.8907V11.8907ZM15.5853%2016.2787C14.6636%2016.268%2013.8924%2015.5006%2013.8986%2014.6004C13.9048%2013.692%2014.6716%2012.9481%2015.602%2012.9479C16.5427%2012.9477%2017.2871%2013.6781%2017.2882%2014.6026C17.2893%2015.5333%2016.521%2016.2896%2015.5853%2016.2787Z%22%20fill%3D%22%230068FE%22/%3E%3Cpath%20d%3D%22M8.0481%2016.2438C9.39854%2014.5856%2010.6939%2012.9885%2011.9984%2011.3989C12.2464%2011.0968%2012.3662%2010.7671%2012.3731%2010.3807C12.3761%2010.2135%2012.3261%2010.1646%2012.1596%2010.165C11.6056%2010.1666%206.41195%2010.165%206.41195%2010.165V11.4709H10.4978C10.4424%2011.543%207.83556%2014.7218%206.57932%2016.2403C6.37112%2016.4919%206.26503%2016.7645%206.25401%2017.0936C6.24628%2017.3242%206.28864%2017.4139%206.52267%2017.4211V17.4217H11.9356C12.1782%2017.4217%2012.3749%2017.225%2012.3749%2016.9823V16.2487V16.2438H8.0481V16.2438Z%22%20fill%3D%22%230068FE%22/%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.948%2026.1338C6.03613%2027.1172%207.26917%2027.9424%208.61108%2028.5752V26.1338H4.948ZM0.00268555%2014.7119C0.0775146%2010.7393%201.69666%207.14453%204.28479%204.50293C4.0459%204.98242%203.83435%205.47949%203.64661%205.99121C2.58862%208.87598%202.31299%2011.8506%202.69116%2014.8916C2.95862%2017.042%203.55518%2019.0869%204.63391%2020.9775C4.8269%2021.3154%205.02271%2021.6582%205.26489%2021.9609C5.76672%2022.5879%205.80981%2023.2725%205.59888%2024.0049C5.4873%2024.3926%205.32227%2024.75%205.11304%2025.082C4.95691%2025.3291%204.77612%2025.5635%204.57434%2025.7842C1.81921%2023.1201%200.0819092%2019.4102%200.00280762%2015.2939C0.000976562%2015.1963%200%2015.0986%200%2015C0%2014.9033%200.000854492%2014.8076%200.00268555%2014.7119Z%22%20fill%3D%22%230068FE%22/%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M24.8226%2026.3367C22.191%2028.6189%2018.7568%2029.9998%2015%2029.9998C11.1449%2029.9998%207.62952%2028.5457%204.97241%2026.156C6.32458%2026.1921%207.61877%2025.9031%208.86353%2025.3464C8.97681%2025.2957%209.06262%2025.3113%209.16443%2025.364C12.2258%2026.9646%2015.5131%2027.5125%2018.926%2027.3962C20.9574%2027.3269%2022.9333%2027.0046%2024.8226%2026.3367Z%22%20fill%3D%22%23015BDF%22/%3E%3C/svg%3E"
										alt=""></a>
							</div>
							<div v-if="page.socials_chat && page.socials_chat.telegram ">
								<a :href="page.socials_chat.telegram" target="_blank">
									<img class="telegram-logo"
										src="https://omnisales.worldfone.vn/portal/assets/images/icon/telegram.png"
										alt=""></a>
							</div>
							<div v-if="page.socials_chat && page.socials_chat.viber ">
								<a :href="page.socials_chat.viber" target="_blank">
									<img class="viber-logo"
										src="https://omnisales.worldfone.vn/portal/assets/images/icon/viber.png"
										alt=""></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="body">
			<div class="chatbox">
				<!-- {{test123}} -->
				<div class="chat-content-w scroll1">
					<div class="chat-content kkkk">
						<div v-for="(message, index_message) in messages" class="chat-message chat-message-main" :class="{self:message.user_id==st_token}">
							<div class="message-sender" v-if="(!isHiddenName(index_message) && (message.unsend == undefined ||  message.unsend != 1))|| ((isHiddenName(index_message) && messages[index_message - 1] != undefined && messages[index_message - 1]['unsend'] != undefined && messages[index_message - 1]['unsend'] ==1) && (message.unsend == undefined ||  message.unsend != 1))">
								<img v-if="message.user_id!=st_token" class="chat-message-avatar" :alt="message.name"
									:title="message.name" :src="message.profile_pic"
									:style="'border:1px solid #'+page.color">
								<p class="user-name" v-if="message.user_id!=st_token" :style="{'color':page.color}">
									{{message.name}}
								</p>
							</div>
							<div v-if="message.unsend == undefined ||  message.unsend != 1">
								<div class="chat-message-content-w" v-if="message.text !='' || message.url !=''">
									<template v-if="message.unsend">
										<div class="chat-message-content">
											<span class="message"
												:style="[message.user_id!=st_token ? {'background-color':'#f0f0f0', 'color': '#969ca7'}:{'background-color':page.color, 'color': '#fff'}]">{{$t('unsend_message')}}</span>
										</div>
									</template>
									<template v-else>
										<template v-if="message.type=='text'">
											<div class="chat-message-content">
												<span class="message" v-if="message.user_id != st_token"
													v-html="detectURL(message.text)"
													:style="[message.user_id!=st_token ? {'background-color':'#f0f0f0', 'color': '#65676b'}:{'background-color':page.color, 'color': '#fff'}]"></span>
												<span class="message" v-else
													:style="[message.user_id!=st_token ? {'background-color':'#f0f0f0', 'color': '#65676b'}:{'background-color':page.color, 'color': '#fff'}]">{{restoreHtmlTag(message.text)}}</span>
											</div>
										</template>
										<div class="chat-message-content" v-else-if="message.type=='image'">
											<a :href="message.url">
												<img style="width: 100%;" :src="message.url" :alt="message.text"
													:title="message.text">
											</a>
										</div>
										<div class="chat-message-content"
											v-else-if="message.type=='link' || message.type=='url'">
											<a :href="message.url" target="_blank">{{message.text ? message.text :
												message.url}}</a>
										</div>
									</template>
								</div>
								<template v-if="message.attachments">
									<template v-if="message.type == 'rating'">
										<div class="chat-message-content-w">
											<div class="chat-message-content">
												<div class="template_list">
													<div class="slider-container">
														<div class="slider">
															<div class="slides">
																<div class="slide slide--feedback">
																	<div class="slide__text">
																		<div class="detail"
																			:style="{'border':'1px solid '+page.color}"
																			style="border-radius: 20px;">
																			<div class="title"
																				:style="{'color':page.color}">
																				{{message.attachments.payload.title}}</div>
																			<div class="des" v-if="!message.is_rated">
																				{{message.attachments.payload.subtitle}}
																			</div>
																			<template
																				v-if="message.is_rated && message.rating_star">
																				<div class="title mt-1"
																					style="margin: 10px 0 0px;">
																					<!-- <div class="title-rating" style="margin-bottom: 5px;    font-weight: 600;"> -->
																					<!-- {{$t('result')}} -->
																					<!-- </div> -->
																					<div class="rating mb-1">
																						<ul class="list">
																							<li v-for="star in max_stars"
																								class="star active">
																								<!-- <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
																									<g clip-path="url(#clip0_79_315)">
																									<path d="M0.823324 13.1821C2.7133 13.048 4.4574 12.9192 6.20149 12.8036C8.29466 12.6642 10.3904 12.5472 12.4823 12.3803C12.6764 12.3645 12.933 12.0937 13.0177 11.8834C14.3957 8.45256 15.7491 5.0112 17.1089 1.57247C17.1806 1.39107 17.2535 1.21099 17.3877 0.878418C17.514 1.17681 17.5961 1.3569 17.669 1.54093C19.0106 4.94022 20.36 8.33557 21.6834 11.7414C21.8619 12.2015 22.0625 12.3947 22.5965 12.4263C26.2462 12.6392 29.892 12.9074 33.5391 13.1598C33.6394 13.1664 33.7384 13.1887 33.965 13.2216C32.8318 14.1943 31.7846 15.0934 30.736 15.9925C28.8877 17.5752 27.0447 19.1644 25.1859 20.7326C24.8603 21.0073 24.7835 21.2466 24.8955 21.6791C25.8177 25.2387 26.7047 28.8076 27.6008 32.3751C27.6529 32.5815 27.692 32.7892 27.7623 33.1086C27.455 32.9206 27.2361 32.7918 27.0225 32.6551C23.9889 30.7202 20.9514 28.7931 17.9321 26.8385C17.5205 26.5716 17.2405 26.59 16.8406 26.8477C13.8369 28.7879 10.8177 30.7044 7.80361 32.6288C7.56655 32.78 7.32558 32.9246 6.99994 33.1244C7.51444 31.0817 8.0055 29.1244 8.49916 27.1684C8.95244 25.3754 9.37968 23.5746 9.87724 21.7934C10.027 21.2571 9.88897 20.9679 9.4969 20.6353C6.77851 18.3337 4.07575 16.0109 1.36909 13.6948C1.2232 13.5699 1.08774 13.4319 0.822021 13.1834L0.823324 13.1821Z" fill="#FDBF00"/>
																									</g>
																									<defs>
																									<clipPath id="clip0_79_315">
																									<rect width="33.1417" height="32.246" fill="white" transform="translate(0.823486 0.876953)"/>
																									</clipPath>
																									</defs>
																									</svg> -->
																								<svg :class="star <= message.rating_star ? 'light-start':''"
																									width="34" height="34"
																									viewBox="0 0 34 34"
																									fill="#cdcdcd"
																									xmlns="http://www.w3.org/2000/svg"
																									style="margin: 0 2.5px;">
																									<g
																										clip-path="url(#clip0_79_315)">
																										<path
																											d="M0.823324 13.1821C2.7133 13.048 4.4574 12.9192 6.20149 12.8036C8.29466 12.6642 10.3904 12.5472 12.4823 12.3803C12.6764 12.3645 12.933 12.0937 13.0177 11.8834C14.3957 8.45256 15.7491 5.0112 17.1089 1.57247C17.1806 1.39107 17.2535 1.21099 17.3877 0.878418C17.514 1.17681 17.5961 1.3569 17.669 1.54093C19.0106 4.94022 20.36 8.33557 21.6834 11.7414C21.8619 12.2015 22.0625 12.3947 22.5965 12.4263C26.2462 12.6392 29.892 12.9074 33.5391 13.1598C33.6394 13.1664 33.7384 13.1887 33.965 13.2216C32.8318 14.1943 31.7846 15.0934 30.736 15.9925C28.8877 17.5752 27.0447 19.1644 25.1859 20.7326C24.8603 21.0073 24.7835 21.2466 24.8955 21.6791C25.8177 25.2387 26.7047 28.8076 27.6008 32.3751C27.6529 32.5815 27.692 32.7892 27.7623 33.1086C27.455 32.9206 27.2361 32.7918 27.0225 32.6551C23.9889 30.7202 20.9514 28.7931 17.9321 26.8385C17.5205 26.5716 17.2405 26.59 16.8406 26.8477C13.8369 28.7879 10.8177 30.7044 7.80361 32.6288C7.56655 32.78 7.32558 32.9246 6.99994 33.1244C7.51444 31.0817 8.0055 29.1244 8.49916 27.1684C8.95244 25.3754 9.37968 23.5746 9.87724 21.7934C10.027 21.2571 9.88897 20.9679 9.4969 20.6353C6.77851 18.3337 4.07575 16.0109 1.36909 13.6948C1.2232 13.5699 1.08774 13.4319 0.822021 13.1834L0.823324 13.1821Z" />
																									</g>
																									<defs>
																										<clipPath
																											id="clip0_79_315">
																											<rect
																												width="33.1417"
																												height="32.246"
																												fill="#cdcdcd"
																												transform="translate(0.823486 0.876953)" />
																										</clipPath>
																									</defs>
																								</svg>
																							</li>
																						</ul>
																					</div>
																				</div>

																				<div class="title"
																					style="font-weight: 500;font-size: 1rem;"
																					:style="{'color':page.color}">
																					<!-- {{$t('feedback')}}: -->
																					{{message.rating_recommend}}
																				</div>
																			</template>
																			<button class="button" type="button" v-else
																				@click.prevent="openFormRating(message)"
																				:style="styleObject">{{message.attachments.payload.button_title.charAt(0).toUpperCase()
																				+
																				message.attachments.payload.button_title.slice(1).toLowerCase()}}</button>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</template>
									<template v-else>
										<div class="chat-message-content-w" v-for="file in message.attachments">
											<div id="greenBar">
												<i class="fa fa-spinner fa-spin" aria-hidden="true"
													v-if="index_message==keyAddFile && keyAddFile!=0"></i>
												<i class="fa fa-check" aria-hidden="true" v-if="message.send_success==1 "
													style="font-size: 1em;opacity: .5;"></i>
											</div>
											<template v-if="message.unsend">
												<div class="chat-message-content">
													<span class="message"
														:style="[message.user_id!=st_token ? {'background-color':'#f0f0f0', 'color': '#969ca7'}:{'background-color':page.color, 'color': '#fff'}]">{{$t('unsend_message')}}</span>
												</div>
											</template>
											<template v-else>
												<div class="chat-message-content">
													<a :href="file.url" target="_blank" v-if="file.type == 'image'">
														<img style="margin-bottom: 5px;max-width: 320px;" :src="file.url"
															:alt="file.text" :title="file.text">
													</a>
													<a :href="file.url" target="_blank" v-if="file.type == 'audio'">
														<audio controls>
															<source :src="file.url" type="audio/mpeg">
														</audio>
													</a>
													<div class="video_content" v-else-if="file.type == 'video'"
														style="width: 320px;padding:10px 5%;border-radius: 10px;">
														<video style="width:100%" height="190" controls>
															<source :src="file.url" type="video/mp4">
															Your browser does not support the video tag.
														</video>
														<div class="video-icon">
															<img
																src="https://omnisales.worldfone.vn/portal/assets/images/video.svg">
															<div class="title">
																<h5>{{file.title}}</h5>
																<div v-if="file.file_size != undefined">
																	<span>{{Math.round(file.file_size/(1024*1024)*100)/100}}
																		MB</span>
																</div>
															</div>
														</div>
													</div>
													<div class="template_list" v-else-if="file.type=='template'">
														<template v-if="file.payload.template_type == 'generic'">
															<div class="slider-container">
																<div class="slider">
																	<div class="slides" :id="'slides__' + index_message"
																		:data-elements="file.payload.elements.length">
																		<div v-for="(element, index) in file.payload.elements"
																			:id="'slide__' + index_message + '_' + index"
																			class="slide"
																			:style="{'border':'1px solid '+page.color}"
																			style="border-radius: 20px;overflow: hidden;">
																			<div class="slide__text">
																				<img :src="element.image_url" alt="">
																				<div class="detail" style="margin:0">
																					<div class="title"
																						:style="{'color':page.color}">
																						{{element.title}}</div>
																					<div class="des text-center">
																						{{element.subtitle}}</div>

																					<template v-for="button in element.buttons">
																						<a v-if="button.type=='postback'"
																							v-on:click="send_postback(message.id, button.payload, button.title, 'generic')"
																							class="button"
																							:style="styleObject">{{button.title}}</a>
																						<a v-if="button.type=='web_url'"
																							:href="button.url" class="button"
																							target="_blank"
																							:style="styleObject">{{button.title}}</a>
																						<a v-if="button.type=='phone_number'"
																							:href="'tel:' + button.payload" target="_system" class="button"
																							:style="styleObject">{{button.title}}</a>
																					</template>

																				</div>
																			</div>
																		</div>

																	</div>
																</div>

															</div>
															<div class="wrap-arrow wrap-arrow-prev">
																<div class="inner-arrow">
																	<a class="slide__prev" :id="'slide__prev_' + index_message"
																		@click.prevent="changePrev(index_message)"
																		:href="'#slide__' + index_message + '_' + (file.payload.elements.length - 1)"
																		title="Prev" :style="{'border-color':page.color}"></a>
																	<!-- <a class="slide__prev" :id="'slide__prev_' + index_message" :href="'#slide__' + index_message + '_' + (file.payload.elements.length - 1)" title="Prev"></a> -->
																</div>
															</div>
															<div class="wrap-arrow wrap-arrow-next">
																<div class="inner-arrow">
																	<a class="slide__next" :id="'slide__next_' + index_message"
																		@click.prevent="changeNext(index_message)"
																		:href="'#slide__' + index_message + '_1'" title="Next"
																		:style="{'border-color':page.color}"></a>
																	<!-- <a class="slide__next" :id="'slide__next_' + index_message" :href="'#slide__' + index_message + '_1'" title="Next"></a> -->
																</div>
															</div>
															<div class="text-center" style=" margin-top: -5px;">
																<ul class="slick-dots" style="display: inline-table;   "
																	role="tablist">
																	<li v-for="(element, index) in file.payload.elements"
																		class="slide__dot"
																		:class="(index==0)?'slick-active slide__' + index_message + '_' + index:'slide__' + index_message + '_' + index">
																		<button type="button" data-role="none" role="button"
																			tabindex="0" :style="styleObject">1</button>
																	</li>
																</ul>
															</div>

														</template>
														<template v-else-if="file.payload.template_type == 'media'">
															<div class="slider-container">
																<div class="slider">
																	<div class="slides" :id="'slides__' + index_message"
																		:data-elements="file.payload.elements.length">
																		<div v-for="(element, index) in file.payload.elements"
																			:id="'slide__' + index_message + '_' + index"
																			class="slide">
																			<div class="slide__text">
																				<img :src="element.url" alt=""
																					v-if="element.media_type == 'image'">
																				<video width="320" height="240"
																					v-else-if="element.media_type == 'video'"
																					controls>
																					<source :src="element.url" type="video/mp4">
																					Your browser does not support the video tag.
																				</video>
																				<div class="detail">
																					<!-- <div class="title" :style="{'color':page.color}">{{element.title}}</div>
														<div class="des">{{element.subtitle}}</div> -->
																					<template v-for="button in element.buttons">
																						<a v-if="button.type=='postback'"
																							v-on:click="send_postback(message.id, button.payload, button.title, 'generic')"
																							class="button">{{button.title}}</a>
																						<a v-if="button.type=='web_url'"
																							:href="button.url" class="button"
																							target="_blank">{{button.title}}</a>
																						<a v-if="button.type=='phone_number'"
																							:href="'tel:' + button.payload" class="button"
																							:style="styleObject" target="_system">{{button.title}}</a>
																					</template>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</template>
														<template v-else-if="file.payload.template_type == 'ticket'">
															<div class="slider-container" v-if="file.payload.template_data">
																<div class="slider slider--ticket">
																	<div class="slides" :id="'slides__' + key_message">
																		<div class="slide">
																			<div class="slide__text slide__text--ticket">
																				<h3 class="slide__text--ticket__title">
																					{{file.payload.template_data.title}}</h3>
																				<h6 class="slide__text--ticket__subtitle">
																					{{file.payload.template_data.subtitle}}</h6>
																				<template
																					v-if="file.payload.template_data.params">
																					<ul class="table-content-list pl-0">
																						<li
																							v-for="param in file.payload.template_data.params">
																							<div class="item">
																								<span>{{param.title}}</span>
																								<span
																									class="">{{param.value}}</span>
																							</div>
																						</li>
																					</ul>
																				</template>
																				<div class="detail detail--ticket text-center">
																					<template
																						v-for="button in file.payload.template_data.buttons">
																						<a v-if="button.type=='postback'"
																							v-on:click="send_postback(message.id, button.payload, button.title, 'generic')"
																							class="button">{{button.title}}</a>
																						<a v-if="button.type=='web_url'"
																							:href="button.url" class="button"
																							target="_blank">{{button.title}}</a>
																						<a v-if="button.type=='phone_number'"
																							:href="'tel:' + button.payload" target="_system" class="button"
																							:style="styleObject">{{button.title}}</a>
																					</template>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</template>
														<div v-else>
															<ul class="list_ul">
																<li v-for="(element, index) in file.payload.elements">
																	<div v-if="element.default_action && element.default_action.type=='web_url'"
																		class="clearfix">
																		<a :href="element.default_action.url"
																			:title="element.title" target="_blank">
																			<img :src="element.image_url" />
																			<h3>{{element.title}}</h3>
																			<p v-if="element.description">
																				{{element.description}}
																			</p>
																		</a>
																	</div>
																	<div v-else-if="element.default_action && element.default_action.type=='postback'"
																		v-on:click="send_postback(message.id, element.default_action.payload, element.title, 'attachment_list')"
																		class="clearfix">
																		<img :src="element.image_url" />
																		<h3>{{element.title}}</h3>
																		<p v-if="element.description">{{element.description}}
																		</p>
																	</div>
																	<div v-else class="clearfix">
																		<img :src="element.image_url" />
																		<h3>{{element.title}}</h3>
																		<p v-if="element.description">{{element.description}}
																		</p>
																	</div>
																</li>
															</ul>
														</div>
													</div>

													<a class="file_pdf" :href="file.url" target="_blank"
														v-if="file.type == 'file' && (getExtension(file.title)=='pdf' || getExtension(file.title)=='docx' || getExtension(file.title)=='xlsx'|| getExtension(file.title)=='xls'|| getExtension(file.title)=='doc'|| getExtension(file.title)=='rar'|| getExtension(file.title)=='zip'|| getExtension(file.title)=='ppt'|| getExtension(file.title)=='pptx')"
														style="width: 320px;padding:10px 5%;border-radius: 10px;">
														<div class="video-icon">
															<img :src="'/assets/images/'+getExtension(file.title)+'_icon.svg'">
															<div class="title">
																<h5>{{file.title}}</h5>
																<div v-if="file.file_size != undefined">
																	<span>{{Math.round(file.file_size/(1024*1024) *100)/100}}
																		MB</span>
																</div>
															</div>
														</div>

														<!-- {{file.title}} -->
													</a>
													<a :href="file.url" class="file_pdf" target="_blank"
														v-else-if="file.type == 'file' && (getExtension(file.title)!='pdf' && getExtension(file.title)!='docx' && getExtension(file.title)!='xlsx')"
														style="width: 320px;padding:10px 5%;border-radius: 10px;">
														<div class="video-icon">
															<div class="img"
																style="background-image: url('/assets/images/icon.svg');width: 42px;height:52px;background-size:100% 100%">
																<span>{{getExtension(file.title)}}</span>
															</div>
															<!-- <img src="/assets/images/icon.svg" > -->
															<div class="title">
																<h5>{{file.title}}</h5>
																<div v-if="file.file_size != undefined">
																	<span>{{Math.round(file.file_size/(1024*1024) *100)/100}}
																		MB</span>
																</div>
															</div>
														</div>
													</a>
													<!-- <a :href="file.url" target="_blank" v-else>{{message.text ? message.text : message.url}}</a> -->
												</div>
											</template>
										</div>
									</template>
								</template>

								<div v-if="message.quick_replies && message.quick_replies.status==1 && index_message == Object.keys(messages).length - 1"
									class="quick-replies" style="margin-left:30px">
									<template v-for="(reply, index) in message.quick_replies.data">
										<div class="reply" v-if="reply.content_type=='text'"
											:class="(page.important_button && page.important_button.includes(reply.title)) ? 'active' :''"
											:style="styleObject"
											v-on:click="send_postback(message.id, reply.payload, reply.title, 'reply')">
											<a :style="{'color':'inherit'}">{{reply.title}}</a>
										</div>
										<div class="reply" v-if="reply.content_type=='postback'"
											:class="(page.important_button && page.important_button.includes(reply.title)) ? 'active' :''"
											v-on:click="send_postback(message.id, reply.payload, reply.title, 'reply')"
											:style="styleObject">
											<a :style="{'color':'inherit'}">{{reply.title}}</a>
										</div>
										<div class="reply" :id="'location_'+message.id"
											v-if="reply.content_type=='location'"
											:class="(page.important_button && page.important_button.includes(reply.title)) ? 'active' :''"
											v-on:click="send_postback(message.id, reply.payload, reply.title, 'location')"
											:style="styleObject">
											<a :style="{'color':'inherit'}">{{reply.title}}</a>
										</div>
										<div class="reply" v-if="reply.content_type=='web_url'"
											:class="(page.important_button && page.important_button.includes(reply.title)) ? 'active' :''"
											:style="styleObject">
											<a :href="reply.payload" target="_blank"
												:style="{'color':'inherit'}">{{reply.title}}</a>
										</div>
										<div class="reply" v-if="reply.content_type=='phone_number'"
											:class="(page.important_button && page.important_button.includes(reply.title)) ? 'active' :''"
											:style="styleObject">
											<a :href="'tel:' + reply.payload" target="_system"
												:style="{'color':'inherit'}">{{reply.title}}</a>
										</div>
									</template>
								</div>
							</div>
							<div :data-time="message.date_added" class="chat-message-date" v-show="(!isHiddenTime(index_message) && (message.unsend == undefined || message.unsend != 1 )) || ((messages[index_message + 1] != undefined &&  messages[index_message + 1]['unsend'] != undefined && messages[index_message + 1]['unsend'] ==1)  && (message.unsend == undefined || message.unsend != 1 ))">{{message.date}}</div>
							<!-- <div :data-time="message.date_added" class="chat-message-date" v-show="(!isHiddenName(index_message) && (message.unsend == undefined ||  message.unsend != 1))|| (isHiddenName(index_message) && messages[index_message + 1] != undefined && messages[index_message + 1]['unsend'] != undefined && messages[index_message + 1]['unsend'] ==1)">{{message.date}}</div> -->
						</div>
						<div v-if="show_typing" class="chat-message">
							<div class="chat-message-content-w">
								<div class="chat-message-content">
									<span class="message" :style="{'background-color':page.color, 'color': '#fff'}">
										<div class="loading-dots">
											<div class="loading-dots--dot"></div>
											<div class="loading-dots--dot"></div>
											<div class="loading-dots--dot"></div>
										</div>
									</span>
								</div>
							</div>
						</div>

						<app-rating-vietjet v-if="show_rating && page.parent_user =='C1184'"
							:config="customerFeedbackConfig"></app-rating-vietjet>
						<app-rating v-else-if="show_rating" :config="customerFeedbackConfig"
							@close-feedback-form="closeFormRating"></app-rating>
						<!-- <app-notification ></app-notification> -->
					</div>
					<!-- <section v-if="show_suggest" aria-label="predictive suggestions"
						class="suggestions PredictiveSuggestions__list__container PredictiveSuggestions__list__container--desktop PredictiveSuggestions--collapsed"
						id="predictive-suggestions-container">
						<div class="PredictiveSuggestions__list__title PredictiveSuggestions__list__title--animate-in">
							<button type="button" class="PredictiveSuggestions__suggestions-heading"
								id="predictive-suggestions-heading" tabindex="0">
								Đề xuất
							</button>
						</div>
						<div class="PredictiveSuggestions__list__items PredictiveSuggestions__list__items--animate-in">
							<ul class="PredictiveSuggestions__list PredictiveSuggestions--animating-list-up PredictiveSuggestions__list--desktop"
								id="predictive-suggestions-list">
								<li v-for="suggest in suggest_data"
									class="PredictiveSuggestions__list__listItem--desktop" accesskey="f"><button
										v-on:click="clickMenu(suggest.value, suggest.title)"
										class="PredictiveSuggestions__item PredictiveSuggestions__item--starting-height-with-text PredictiveSuggestions__item--animate-flicker"
										tabindex="0" type="button"
										style="color: rgb(240, 14, 14); animation-play-state: paused;"><span
											style="color: rgb(240, 14, 14);">{{suggest.title}}</span></button></li> -->

					<!-- <li class="PredictiveSuggestions__list__listItem--desktop" accesskey="g"><button class="PredictiveSuggestions__item PredictiveSuggestions__item--starting-height-with-text PredictiveSuggestions__item--animate-flicker" tabindex="0" type="button" style="color: rgb(240, 14, 14); animation-play-state: paused;"><span style="color: rgb(240, 14, 14);">Bảo hiểm du lịch cho Covid-19 (Tune Protect)</span></button></li>
                        <li class="PredictiveSuggestions__list__listItem--desktop" accesskey="h"><button class="PredictiveSuggestions__item PredictiveSuggestions__item--starting-height-with-text PredictiveSuggestions__item--animate-flicker" tabindex="0" type="button" style="color: rgb(240, 14, 14); animation-play-state: paused;"><span style="color: rgb(240, 14, 14);">Bay an toàn với VietJet Air</span></button></li> -->
					<!-- </ul>
						</div>
					</section> -->
				</div>
				<div id="modalStatus" class="modal-wrapper">
					<div class="modal">
						<a href="#close" title="Close" class="close" @click="closeModal()">X</a>
						<div class="modal-header">
							<h2>{{error.title}}</h2>
						</div>
						<div class="modal-content">
							<p>{{error.description}}</p>
						</div>
					</div>
				</div>
				<div id="modal-phonenumber" class="modal-wrapper">
					<div class="modal">
						<a href="#close" title="Close" class="close" @click="closePhoneModal()">X</a>
						<div class="modal-header">
							<h4>{{phoneNumber}}</h4>
						</div>
						<div class="modal-content">
							<div style="width: 100%; margin-bottom: 10px;">
								<a href="#" @click.prevent="copyPhoneNumber()" style="color: initial"><strong>Sao
										chép</strong></a>
							</div>
							<div style="width: 100%;">
								<a :href="'tel:' + phoneNumber" style="color: initial"><strong>Gọi điện</strong></a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="chat-controls">
				<div v-if="show_menu" class="mini-menu">
					<ul>
						<li v-for="menu_item in page.listmenu">
							<a v-if="menu_item.type=='postback'"
								v-on:click="clickMenu(menu_item.value, $t(menu_item.name)/*menu_item.name*/)">{{$t(menu_item.name)}}</a>
							<a v-else-if="menu_item.type=='website'" v-on:click="show_menu = false"
								:href="menu_item.value" target="_blank">{{$t(menu_item.name)}}</a>
							<a v-else-if="menu_item.type=='phone'" v-on:click="show_menu = false"
								:href="'tel:'+menu_item.value">{{$t(menu_item.name)}}</a>
						</li>
						<!-- <li>Gọi điện</li> -->
						<!-- <li>Hướng dẫn chung</li> -->
					</ul>
				</div>
				<div v-if="messageInputLength > 1024" style="font-size: .7em; color: #c00;text-align: center;">( Bạn
					không được nhập quá 1024 ký tự )</div>
				<div class="chat-input flex_container" style="display: flex; width: 100%; color: #808080;">
					<!-- <div class="flex_item_left">
                    <i v-if="page.listmenu" @click="show_menu = !show_menu" class="fas fa-bars" style="cursor: pointer;"></i>
                    <i @click="upload_file" class="fas fa-paperclip" style="margin: 0px 10px 0 3px;cursor: pointer;"></i>
                    <input style="display: none; visibility: hidden;" ref="fileImage" type="file" accept="file_extension|audio/*|video/*|image/*|media_type" @change="onFileSelected" name="" value="" placeholder="">
                  </div>  -->
					<!-- $t('title_ready_enter_text') -->
					<textarea class="flex_item_right " :class="(microphone_open==1)?'voice_open':''"
						id="flex_item_right" ref="input_chat" style="height: 28px; flex: 1;" v-model="message_input"
						@keyup.enter.exact.stop.prevent="enter_chat()" v-on:keyup="handleKeyUp"
						@paste="onPaste" @input="mixin_autoResize_resize" :placeholder="$t('title_ready_enter_text')"></textarea>
					<i class="fa fa-spinner fa-spin loadding_input" aria-hidden="true" v-if="loadding==1"
						:style="styleObject"></i>
					<!-- <textarea class="flex_item_right " ref="input_chat" style="height: 28px; flex: 1;"
						v-model="message_input" @keyup.enter.exact.stop.prevent="enter_chat()"
						:placeholder="$t('title_ready_enter_text')"></textarea> -->
						<div class="flex_item icon-sendfile" :class="(disable_button==1)?'disabled-button':''" :style="styleObject">
						<!-- <svg width="86" v-if="microphone_open==1" style="position: absolute; z-index: 99; left: 30%;" height="32" viewBox="0 0 86 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="15" width="2" height="2" rx="1" fill="#2D84FD"></rect><rect x="6" y="12" width="2" height="8" rx="1" fill="#2D84FD"></rect><rect x="12" y="9" width="2" height="14" rx="1" fill="#2D84FD"></rect><rect x="18" y="14" width="2" height="4" rx="1" fill="#2D84FD"></rect><rect x="24" y="8" width="2" height="16" rx="1" fill="#2D84FD"></rect><rect x="30" y="9" width="2" height="14" rx="1" fill="#2D84FD"></rect><rect x="36" y="11" width="2" height="10" rx="1" fill="#2D84FD"></rect><rect x="42" y="11" width="2" height="10" rx="1" fill="#2D84FD"></rect><rect x="48" y="11" width="2" height="10" rx="1" fill="#2D84FD"></rect><rect x="54" y="9" width="2" height="14" rx="1" fill="#2D84FD"></rect><rect x="60" y="11" width="2" height="10" rx="1" fill="#2D84FD"></rect><rect x="66" y="8" width="2" height="16" rx="1" fill="#2D84FD"></rect><rect x="72" y="11" width="2" height="10" rx="1" fill="#2D84FD"></rect><rect x="78" y="14" width="2" height="4" rx="1" fill="#2D84FD"></rect><rect x="84" y="15" width="2" height="2" rx="1" fill="#2D84FD"></rect></svg> -->
						<i v-if="page.listmenu" @click="show_menu = !show_menu" class="fas fa-bars" style="cursor: pointer;"></i>
						<i @click="upload_file" class="fas fa-paperclip" style="padding: 8px;cursor: pointer;"></i>
						<i class="microphone fas fa-microphone" v-if="show_microphone==1 && microphone_show==0" :data-mic="show_microphone" @click="openMic();microphone_show=1" style="padding: 8px;cursor: pointer;"></i>
						<i class="microphone open fas fa-microphone" v-else-if="show_microphone==1 && microphone_show==1" :data-mic="show_microphone" 	@click="microphone_show=0;no_send_file=1" style="padding: 8px;cursor: pointer;" :style="styleObject"></i>
						<input id="FileSelectedValue" style="display: none; visibility: hidden;" ref="fileImage" type="file" accept="file_extension|audio/*|video/*|application/pdf|image/*|media_type" @change="onFileSelected" name="" value="" placeholder="">

					</div>
					<div class="flex_item sendchat_box"  :class="(disable_button==1)?'disabled-button':''" :style="styleObject">
						<div class="sendchat_button" @click.prevent="enter_chat()"
							style="    padding: 7px; border-radius: 50%;    margin-top: 0;margin-top: 1px;"
							:style="styleObject">
							<svg width="16" height="15" viewBox="0 0 23 22" fill="white"
								xmlns="http://www.w3.org/2000/svg" :style="styleObject">
								<g clip-path="url(#clip0_54_517)">
									<path
										d="M9.39295 15.6391C12.5928 11.7903 15.7611 7.97932 18.9285 4.16832C18.9105 4.14944 18.8934 4.13055 18.8754 4.11167C18.2671 4.62694 17.6571 5.13951 17.0515 5.65747C13.6399 8.57102 10.2274 11.4837 6.82298 14.4044C6.57697 14.6157 6.37512 14.6571 6.06244 14.5474C4.28905 13.9251 2.50755 13.328 0.726949 12.7273C0.371009 12.6077 0.0439056 12.4602 0.00335549 12.0331C-0.0398979 11.5817 0.271887 11.3821 0.621519 11.1995C7.652 7.53689 14.6807 3.86977 21.7103 0.203557C22.0067 0.0488869 22.2996 -0.104884 22.6366 0.0983453C22.9646 0.296179 23.0385 0.595627 22.9853 0.94903C22.3383 5.25461 21.6895 9.55929 21.0452 13.8649C20.8227 15.354 20.6064 16.845 20.3937 18.335C20.3018 18.9789 19.9243 19.2693 19.3385 19.0706C16.0765 17.9636 12.819 16.8432 9.55965 15.7272C9.5182 15.7128 9.48036 15.6858 9.39475 15.64L9.39295 15.6391Z" />
									<path
										d="M8.37224 16.8474C9.69868 17.2997 10.9512 17.7269 12.2317 18.1639C12.1857 18.261 12.1605 18.3456 12.111 18.413C11.3342 19.4732 10.5502 20.528 9.77617 21.5909C9.54008 21.9156 9.24452 22.0891 8.85253 21.9533C8.47316 21.8229 8.37134 21.4965 8.37134 21.126C8.37134 19.7223 8.37134 18.3186 8.37134 16.8474H8.37224Z"
										fill="white" />
								</g>
								<defs>
									<clipPath id="clip0_54_517">
										<rect width="23" height="22" fill="white" />
									</clipPath>
								</defs>
							</svg>
						</div>
					</div>
					<div role="menu" v-if="show_suggest" class="dropdown-menu dropdown-menu-left dropdown-quickchat"
						id="dropdown-shortcode">
						<div class="list-suggestion">
							<ul class="nav list-suggestion-body">
								<li v-for="(suggestion, key) in suggest_data" class="suggestion-option"
									@click="sendSuggestion(suggestion)" :style="'--hover-color: ' + page.color">
									<div class="row quick-chat-row">
										{{suggestion.text}}
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div role="menu" v-if="images.length" class="dropdown-menu dropdown-menu-left dropdown-quickchat"
						id="dropdown-images">
						<div class="list-image">
							<div class="list-image-body">
								<div v-for="(image, index) in images" class="image-sending"
									style="position: relative; display: inline-block;">
									<i class="fa fa-times btn-closed" @click="removeImage(index)"></i>
									<img :src="image" width="100" height="100" style="margin: 5px">
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="text-center microphone-content" v-if="(microphone_show==1 || audioUrl !='') && disable_button!=1">
					<ul class="nav nav-tabs nav-justified tab-microphone" :style="styleObject">
						<li :class="(recording_tab==0)?'active':''" @click="changeTabActive(0)"><a>{{$t('speech_to_text')}}</a></li>
						<li :class="(recording_tab==1)?'active':''" @click="changeTabActive(1)"><a>{{$t('send_a_record')}}</a></li>
					</ul>
					<div v-show="microphone_open==1 && audioUrl !='' ">
						<audio controls id="myAudio">
							<source id="audioTest" :src="audioUrl" type="audio/mpeg">
						</audio>
					</div>

					<div class="voice_no_active" v-if="microphone_open==0 ">
						<div class="voice-box" :style="styleObject" @click="openMicrophone()">
							<i class="microphone fas fa-microphone"></i>
						</div>
						<div class="content">{{$t('press_to_record')}}</div>
					</div>
					<!-- speed to text -->
					<div class="voice_active" v-if="microphone_open==1 && audioUrl =='' " style="display: flex;">
						<div class="voice_active_left" style="position: relative;    flex: 1;">
							<div class="voice-box voice-box-trash"  style="">
								<i class="fas fa-trash" :style="styleObject" @click="recording_delete=1;no_send_file=1;microphone_open=0;recording_delete=1;microphone_show=0;closeMicrophone($event);" ></i>
							</div>
							<div  class="content" >{{$t('voice_cancel')}}</div>
						</div>
						<div class="voice_active_right" style="position: relative;    flex: 1;">
							<div class="wrapper" style="margin-top: -17px;" >
								<div class="ring" >
									<div class="coccoc-alo-phone coccoc-alo-green coccoc-alo-show" :style="styleObject">
										<div class="coccoc-alo-ph-circle"></div>
										<div class="coccoc-alo-ph-circle-fill"  ></div>
										<div class="coccoc-alo-ph-img-circle" @click="recording_delete=0;closeMicrophone($event)">
											<i class="fas fa-stop"></i>
										</div>
									</div>
								</div>
							</div>
							<div class="content">{{$t('voice_stop')}}</div>
						</div>
					</div>
					<!-- audio  -->
					<div class="voice_active" v-if="microphone_open==1 && audioUrl !='' " style="display: flex;">
						<div class="voice_active_left" style="position: relative;    flex: 1;">
							<div class="voice-box voice-box-trash"  :style="styleObject" @click="no_send_file=1;microphone_open=0;recording_delete=1;microphone_show=0;scriptProcessor='';audioUrl=''" style="">
								<i class="fas fa-trash"></i>
							</div>
							<div  class="content" >{{$t('voice_cancel')}}</div>
						</div>
						<div class="voice_active_right" style="position: relative;    flex: 1;">
							<div class="voice-box"  :style="styleObject"  @click="no_send_file=1;microphone_open=0;recording_delete=0;microphone_show=0;scriptProcessor='';audioUrl='';upload_file_audio()">
								<i class="fa fa-paper-plane" aria-hidden="true"></i>
							</div>
							<div class="content">{{$t('voice_send')}}</div>
						</div>
					</div>

				</div>

			</div>
		</div><!--body-->

		<div class="footer-note" v-if="page.privacy_link">
			<a class="product" target="_blank" :href="page.privacy_link">Quyền riêng tư</a>
		</div>
		<div class="footer-note" v-else>
			<!-- <label class="lang-option"
				v-if="typeof page.languages !== 'undefined' && Object.keys(page.languages).length>0">
				<i :style="{'color': page.color}" class="fas fa-globe"></i> {{$t('language')}}
				<select v-model="lang" @change="setLang($event)">
					<option value="vi">Tiếng Việt</option>
					<option value="en">English</option>
				</select>
			</label> -->
			<template v-if="lang == 'vi' || setting_language == 'vi'">
				<div class="vietjet-privacy C1184"
					v-if="page.privacy && page.privacy.status && page.privacy.status != 0 && page.privacy.content && page.privacy.content != ''"
					style=" margin: 5px 0; ">
					<label for="vietjet-policyCheckbox" v-html="getPrivacyContent(page.privacy.content)"></label>
				</div>
			</template>
			<template v-else-if="lang != undefined">
				<div class="vietjet-privacy C1184"
					v-if="page.languages[lang] && page.languages[lang].privacy && page.languages[lang].privacy.status && page.languages[lang].privacy.status != 0 && page.languages[lang].privacy.content && page.languages[lang].privacy.content != ''"
					style=" margin: 5px 0; ">
					<label for="vietjet-policyCheckbox"
						v-html="getPrivacyContent(page.languages[lang].privacy.content)"></label>
				</div>
			</template>
			<template v-else>
				<div class="vietjet-privacy C1184"
					v-if="page.languages[setting_language] && page.languages[setting_language].privacy && page.languages[setting_language].privacy.status && page.languages[setting_language].privacy.status != 0 && page.languages[setting_language].privacy.content && page.languages[setting_language].privacy.content != ''"
					style=" margin: 5px 0; ">
					<label for="vietjet-policyCheckbox"
						v-html="getPrivacyContent(page.languages[setting_language].privacy.content)"></label>
				</div>
			</template>
			<!-- <div class="vietjet-privacy C1184" v-if="page.privacy && page.privacy.status != 0 && page.privacy.content != '' && (page.parent_user =='C1184' || page.parent_user =='C1504_prod')" style=" margin: 5px 0; ">
				<label for="vietjet-policyCheckbox"> <a href="https://www.vietjetair.com/vi/pages/chinh-sach-ve-quyen-rieng-tu-1702461524009" target="_blank">Chính sách về quyền riêng tư</a></label>
			</div> -->
			<div v-if="page.hide_power_by!=1">
				<span>⚡ by </span><a class="product" target="_blank"
					href="https://worldfone.vn/dich-vu/tong-dai-contact-center-worldfone4x"> Worldfone4Omni</a>
			</div>
		</div>
	</div>

</template>

<script>
	/*import $ from "jquery";
	// import $ from './assets/js/jquery.min.js'
	// Binding of init has to be before intialization!
$('.slick-slider').on('init', (event, slick, currentSlide) => {
let slideIndex = slick.currentSlide;
let slidesLength = slick.slideCount;
});
console.log($('body').html());
// Initialise.
$('.slick-slider').slick({
slidesToShow: 1,
dots: true,
//centerMode: true,
responsive: [
{
breakpoint: 768,
settings: {
  slidesToShow: 1 } }] });





let slideIndex = $('.slick-slide:not(.slick-cloned)').length;
$('.add-slide').on('click', () => {
slideIndex++;
$('.slick-slider').slick('slickAdd', '<li><h3>' + slideIndex + '</h3></li>');
$('.slick-slider').slick('slickGoTo', 'slickCurrentSlide' + 1);
});

$('.remove-slide').on('click', () => {
$('.slick-slider').slick('slickRemove', slideIndex - 1);
if (slideIndex !== 0) {
slideIndex--;
}
});*/
	//# sourceURL=pen.js

	// import io from 'socket.io-client';
	import Rating from '../components/rating.vue';
	import rating_vietjet from '../components/rating_vietjet.vue';
	import notification1 from '../components/notification.vue';
	import sound from '../assets/media/notif.mp3';
	import axios from 'axios';
	export default {
		components: {
			'app-rating': Rating,
			'app-rating-vietjet': rating_vietjet,
			'app-notification': notification1
		},
		props: ['page'/*, 'show_launcher', 'first_component'*/],
		data() {
			return {
				setting_sound: window.livechat.setting_sound,
				setting_noti: window.livechat.setting_noti,
				// setting_language: window.livechat.setting_language,
				new_message_number: 0,
				message_input: '',
				messages: [],
				agent_id: '',
				agent: {
					name: '',
					avatar: '',
				},
				user_has_created: false,
				selectedFile: null,
				current_time_m: ENV.current_time,
				current_time_n: ENV.current_time,
				timer: '',
				timeoutVal: 500, // time it takes to wait for user to stop typing in ms,
				timer_show_typing: '',
				//console.log(livechat.getLanguages());
				lang1: '',
				show_suggest: 0,
				suggest_data: [],
				show_typing: 0,
				show_menu: 0,
				/*menus:[
				{type: 'postback', name: 'Danh mục chính', value: '#daddasadasdas'},
				{type: 'website', name: 'Hướng dẫn chung', value: 'https://omnicxm.worldfone.cloud/omni/botai/view/detail/61c932994a67137a262ab3f2'},
				{type: 'phone', name: 'Gọi hỗ trợ', value: '0366446318'}
				]*/
				// show_notification: 'true',
				slideIndexes: {},
				customerFeedbackConfig: null,
				error: {
					title: '',
					description: '',
				},
				phoneNumber: '',
				keyAddFile: 0,
				msg_idAddFile: '',
				keyAddFileSuccess: '',
				max_stars: 5,
				reloadinterval: 0,
				datawindowInfo: [],
				// typeFileAdd:'',
				// nameFileAdd:'',
				session_url: '',
				session_starttime: '',
				interaction_click: 0,
				interaction_view: 0,
				exact_interaction_click: 0,
				form_interaction_submit: 0,
				interaction_scroll: 0,
				microphone_open: 0,
				microphone_show: 0,
				audioUrl: '',
				stream: [],
				show_microphone: false,
				loadding: 0,
				no_send_file: 0,
				recording_tab: 0,
				recording_delete: 0,
				test123: '',
				blobData: '',
				reload_iframe_click: 0,
				audioContext: '',
				mediaStream: '',
				mediaStreamSource: [],
				scriptProcessor: [],
				audioChunks: [],
				statusMicClose:0,
				images: [],
				disable_button:0,
				timeoutId:''
			}
		},

		computed: {
			styleObject: function () {
				return {
					'--borderColor': this.page.color,
					'--color': this.page.color,
					'--colorHover': '#fff',
				}
			},
			st_token() {
				return this.$store.state.st_token;
			},
			lang() {
				return this.$store.state.lang;
			},
			show_rating() {
				return this.$store.state.show_rating;
			},
			page() {
				return this.$store.state.page;
			},
			hasFocus() {
				return this.$store.state.hasFocus;
			},
			show_launcher() {
				return this.$store.state.show_launcher;
			},
			first_component() {
				return this.$store.state.first_component;
			},
			messageInputLength() {
				return this.message_input.length;
			},
			isHideSolvedButton() {
				return this.page.hide_solved_button;
			},
		},
		methods: {
			addVoiceText: function (value) {
				var _vm = this;
				this.message_input = value;
				setTimeout(function () {
					_vm.mixin_autoResize_resize();
				}, 50);

			},
			openMic() {
				var _vm = this;
				if(_vm.disable_button==1){
					return false;
				}
				navigator.mediaDevices.getUserMedia({ video: false, audio: true })
					.then(stream => {
						stream.getTracks().forEach(function (track) {
							track.stop();
						})
					})
					.catch(error => {
						_vmChat.microphone_open = 0;
					});

			},
			changeTabActive: function (value) {

				if(this.microphone_open==0){
					this.no_send_file=0
					this.recording_tab=value;
				}
			},
			async openMicrophone() {
				let now = new Date();
				this.$refs.input_chat.style.height = '28px';
				now = now.toLocaleTimeString();
				let _vmChat = this;
				_vmChat.message_input = '';
				_vmChat.audioUrl = '';
				_vmChat.microphone_open = 1;
				document.getElementById("audioTest").src = '';
				document.getElementById("myAudio").load();
				_vmChat.audioChunks = [];
				_vmChat.audioContext = ''
				// "microphone_open==1 && audioUrl ==''
				navigator.mediaDevices.getUserMedia({ video: false, audio: true })
					.then(stream => {

						_vmChat.mediaStream = stream;
						// Create a new AudioContext
						_vmChat.audioContext = new (window.AudioContext || window.webkitAudioContext)();
						// Create a media stream source
						_vmChat.mediaStreamSource = _vmChat.audioContext.createMediaStreamSource(_vmChat.mediaStream);
						// Create a script processor node
						_vmChat.scriptProcessor = _vmChat.audioContext.createScriptProcessor(4096, 1, 1);
						// Event handler for audio processing
						_vmChat.scriptProcessor.onaudioprocess = function (event) {
							const audioData = event.inputBuffer.getChannelData(0);
							const audioBuffer = new Float32Array(audioData);
							_vmChat.audioChunks.push(audioBuffer);
						};
						// Connect the nodes
						_vmChat.mediaStreamSource.connect(_vmChat.scriptProcessor);
						_vmChat.scriptProcessor.connect(_vmChat.audioContext.destination);
							_vmChat.statusMicClose=setTimeout(() => {
								_vmChat.closeMicrophone();

						}, 15000); // Dừng sau 7 giây, bạn có thể điều chỉnh thời gian theo ý muốn
						return false;
					}).catch(error => {
						_vmChat.microphone_open = 0;
						alert(error)
					});


			},
			createAudioBlob(audioChunks, sampleRate) {
				const audioData = this.mergeBuffers(audioChunks);
				const wavBuffer = this.encodeWAV(audioData, sampleRate);
				return new Blob([wavBuffer], { type: 'audio/wav' });
			},
			mergeBuffers(audioChunks) {
				const length = audioChunks.reduce((sum, buffer) => sum + buffer.length, 0);
				const result = new Float32Array(length);
				let offset = 0;
				audioChunks.forEach(buffer => {
					result.set(buffer, offset);
					offset += buffer.length;
				});
				return result;
			},
			writeString(view, offset, string) {
				for (let i = 0; i < string.length; i++) {
					view.setUint8(offset + i, string.charCodeAt(i));
				}
			},
			floatTo16BitPCM(output, offset, input) {
				for (let i = 0; i < input.length; i++, offset += 2) {
					const s = Math.max(-1, Math.min(1, input[i]));
					output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
				}
			},
			encodeWAV(audioData, sampleRate) {
				const buffer = new ArrayBuffer(44 + audioData.length * 2);
				const view = new DataView(buffer);



				this.writeString(view, 0, 'RIFF');
				view.setUint32(4, 36 + audioData.length * 2, true);
				this.writeString(view, 8, 'WAVE');
				this.writeString(view, 12, 'fmt ');
				view.setUint32(16, 16, true);
				view.setUint16(20, 1, true);
				view.setUint16(22, 1, true);
				view.setUint32(24, sampleRate, true);
				view.setUint32(28, sampleRate * 2, true);
				view.setUint16(32, 2, true);
				view.setUint16(34, 16, true);
				this.writeString(view, 36, 'data');
				view.setUint32(40, audioData.length * 2, true);
				this.floatTo16BitPCM(view, 44, audioData);

				return view;
			},
			closeMicrophone(event) {
				let _vmChat = this;
				clearTimeout(_vmChat.statusMicClose);

				// if (mediaRecorder && mediaRecorder.state !== "inactive") {
				_vmChat.mediaStream.getTracks().forEach(track => track.stop());
				_vmChat.blobData = '';
				// Merge audio chunks and create a Blob
				const audioBlob = _vmChat.createAudioBlob(_vmChat.audioChunks, _vmChat.audioContext.sampleRate);

				const blobSize = audioBlob.size;
				let mimeType = audioBlob.type;
				_vmChat.test123 = mimeType;
				_vmChat.microphone_show = 0;
				_vmChat.blobData = audioBlob;
				const audioUrl = URL.createObjectURL(audioBlob);
				_vmChat.audioContext == '';
				if (_vmChat.recording_tab == 1) {
					if (_vmChat.recording_delete != 1) {
						_vmChat.audioUrl = audioUrl;
						document.getElementById("audioTest").src = audioUrl;
						document.getElementById("myAudio").load();

						_vmChat.scriptProcessor = '';
						_vmChat.loadding = 0;
						_vmChat.message_input = '';

					} else {
						_vmChat.scriptProcessor = '';
						_vmChat.loadding = 0;
						_vmChat.message_input = '';
						_vmChat.recording_delete = 0;
						_vmChat.blobData = '';
					}
				} else {
					_vmChat.microphone_open = 0;
					_vmChat.loadding = 1;
					// Làm gì đó với audioUrl (ví dụ: hiển thị trong một thẻ audio)
					if (_vmChat.no_send_file == 0) {
						const formData = new FormData();
						formData.append('audio', _vmChat.blobData, 'audio.wav');
						axios.post('/app/v1/public/v3/get_voice_text', formData, {
							params: {
								text: '',
								sender_id: _vmChat.st_token,
								name: window.user.name,
								survey_data: {
									name: window.user.name,
									phone: window.user.phone,
									email: window.user.email,
									address: window.user.address
								},
								properties: window.user.properties
							},
							headers: {
								"Content-Type": "multipart/form-data",
							},
						})
							.then(function (response) {
								if (response.data.status == 1) {
									_vmChat.loadding = 0;
									_vmChat.message_input = ' ';
									_vmChat.addVoiceText(response.data.data)
									let end = new Date();
									end = end.toLocaleTimeString();
									console.log(now + '--' + end)
									_vmChat.scriptProcessor = '';
								} else {
									// _vmChat.test123=JSON.stringify(response.data);
								}
							}).catch(function (jqXHR, textStatus, errorThrown) {
								console.log(textStatus + ": " + jqXHR.status + " " + errorThrown);
								// console.log(error);
								// _vmChat.test123=JSON.stringify(textStatus);
								// _vmChat.scriptProcessor='';
								// _vmChat.message_input = '';
							});
						_vmChat.blobData = '';
					} else {
						_vmChat.loadding = 0;
						_vmChat.message_input = '';
						_vmChat.scriptProcessor = '';
						_vmChat.microphone_open = 0;
						_vmChat.no_send_file = 0
						_vmChat.blobData = '';
					}

				}
				if(_vmChat.scriptProcessor){
					_vmChat.scriptProcessor.disconnect();
					_vmChat.scriptProcessor.onaudioprocess = null;
					_vmChat.scriptProcessor = null;
				}
				if(_vmChat.mediaStreamSource){
					_vmChat.mediaStreamSource.disconnect();
					_vmChat.mediaStreamSource = null;
				}
				if (_vmChat.audioContext) {
					_vmChat.audioContext.close();
				}
			},
			poll: function () {
				var self1 = this;
				var ajax = new XMLHttpRequest();
				ajax.onreadystatechange = function () {
					if (this.readyState === 4 && this.status === 200) {
						if (this.status === 200) {
							try {
								var json = JSON.parse(this.responseText);
								if (json.status == 1) {
									self1.current_time_m = json['ts'];

									self1.add_messages(json['data']);
									self1.poll();

								} else {
									console.log(json.error);
									setTimeout(() => {
										self1.poll();
									}, 3000);
								}
							} catch {
								self1.current_time_m = self1.current_time_m + 3;
								self1.poll();
								return;
							}
						} else {
							setTimeout(() => {
								self1.poll();
							}, 3000);
						}

					} else if (this.status > 299 && this.readyState == 4) {
						setTimeout(() => {
							self1.poll();
						}, 3000);
						console.log('Server Error: ' + ajax.statusText);
					} else {
					}
				}
				ajax.onerror = function () {
					console.log('xmlHTTP Error', ajax.responseText);
					setTimeout(() => {
						self1.poll();
					}, 3000);
				}

				ajax.open('GET', '/app/v1/public/pull/message/' + self1.st_token + '/' + self1.current_time_m, true);
				ajax.send();

			},
			polln: function () {
				var self1 = this;
				var ajax = new XMLHttpRequest();
				ajax.onreadystatechange = function () {
					if (this.readyState === 4 && this.status === 200) {
						if (this.status === 200) {
							try {
								var json = JSON.parse(this.responseText);
								if (json.status == 1) {
									self1.current_time_n = json['ts'];
									json['data'].forEach(function (message, index) {
										switch (message.trigger) {
											case 'rating':
												self1.$store.commit('show_rating', true);
												break;
											case 'suggest':
												self1.show_suggest = true;
												self1.suggest_data = message.suggest;
												setTimeout(function () {
													self1.scrollToEnd();
												}, 250);
												break;
											case "change_language":
												self1.setLangNotificationEvent(message.language);
												break;
											case "unsend_message":
												self1.setUnsendMessage(message);
												break;
											case "edit_message":
												self1.setEditMessage(message);
												break;
											default:
												break;
										}
										// if (message.trigger == 'rating') {
										// 	self1.$store.commit('show_rating', true);
										// } else if (message.trigger == 'suggest') {
										// 	self1.show_suggest = true;
										// 	self1.suggest_data = message.suggest;
										// 	setTimeout(function () {
										// 		self1.scrollToEnd();
										// 	}, 250);
										// 	// self1.$store.commit('show_suggest', true);
										// } else if (message.trigger == 'change_language') {
										// 	self1.setLangNotificationEvent(message.language);
										// }
									});

									self1.polln();

								} else {
									console.log(json.error);
									setTimeout(() => {
										self1.polln();
									}, 3000);
								}
							} catch {
								self1.current_time_n = self1.current_time_n + 3;
								self1.polln();
								return;
							}
						} else {
							setTimeout(() => {
								self1.polln();
							}, 3000);
						}

					} else if (this.status > 299 && this.readyState == 4) {
						setTimeout(() => {
							self1.poll();
						}, 3000);
						console.log('Server Error: ' + ajax.statusText);
					} else {
					}
				}
				ajax.onerror = function () {
					console.log('xmlHTTP Error', ajax.responseText)
					setTimeout(() => {
						self1.polln();
					}, 3000);
				}
				ajax.open('GET', '/app/v1/public/pull/notifications/' + self1.st_token + '/' + self1.current_time_n, true);
				ajax.send();
			},
			mixin_autoResize_resize() {
				let val = this.$refs.input_chat.value;

				if (val == '' || ((Object.keys(val.split(/\r|\r\n|\n/)).length == 1) && this.$refs.input_chat.scrollHeight < 30)) {
					this.$refs.input_chat.style.height = '28px';
				} else {
					this.$refs.input_chat.style.height = "auto";
					this.$refs.input_chat.style.height = `${this.$refs.input_chat.scrollHeight}px`;
				}

			},
			get_messages() {
				var $self = this;
				axios.get('/app/v1/public/v2/get_messages', {
					params: {
						st_token: $self.st_token,
						livechat_id: livechat.getId(),
					}
				}).then((response) => {
					if (response.data.status == 1) {
						var data = response.data.data;
						$self.messages = data;
						$self.current_time_m = response.data.last_mes_time;
					// $self.current_time_n = response.data.last_mes_time;
						$self.poll();
						$self.polln();

						setTimeout(function () {
							$self.insertDateLine();
						}, 150);
						$self.scrollToEnd();
					} else {
					// $self.$emit('first_component', 'survey');
						$self.$store.commit('set_first_component', 'survey');
					// $self.poll();
					// $self.polln();
					}


				}).catch(error => {
					console.log(error);
				});
			},
			add_messages: function (data) {
				var $self = this;
				$self.$store.commit('show_rating', false);
				data.forEach(function (message1, index) {
					var msg_id = message1.msg_id;
					// console.log(msg_id);
					if (typeof msg_id !== 'undefined') {
						var index = $self.messages.findIndex(message => message.msg_id === msg_id);
						console.log(index);
						if (parseInt(index) >= 0) {
							//update đã nhận
							if ($self.msg_idAddFile == msg_id) {
								$self.keyAddFile = 0;
								var msgTemp = message1;
								// $self.$set(msgTemp, 'send_success', 1);
								message1.send_success = 1;
							}
							$self.messages.splice(index, 1, message1);
						} else {
							$self.messages.push(message1);
						}
						// console.log($self.messages)
					} else {
						$self.messages.push(message1);
					}
					if (!message1.delivered && message1.user_id != $self.st_token) {
						$self.sendDeliveredEvent(message1);
					}

					// $self.messages.push(message1);
					$self.new_message_number++;
					$self.$emit('new_message_number', $self.new_message_number);
					// if (message1.user_id!= $self.st_token && $self.setting_sound==true) {
					//   // $self.playSound(sound);
					// }
					if (message1.user_id != $self.st_token) {
						$self.set_show_typing(0);
					}
					if (message1.user_id != $self.st_token && $self.setting_noti == true) {
						$self.showNotification(message1.name, message1.text, message1.profile_pic);
					}
					$self.sortMessages();
				});
				setTimeout(function () {
					$self.scrollToEnd();
				}, 250);


			},
			getPrivacyContent: function (content) {
				var regex = /\[(.*?)\]\((.*?)\)/g;
				var allDetectedText = [...content.matchAll(regex)];
				var replaceText = '';
				$.each(allDetectedText, function (key, detectedText) {
					if (detectedText != undefined && detectedText.length == 3) {
						var url = detectedText[2];
						var title = detectedText[1]
						if (!replaceText.length) replaceText = '<a href=' + url + ' target="_blank" style="text-transform: capitalize;">' + title + '</a>';
						// newContent = newContent.replace(detectedText[0], replaceText);
					}
				})
				return replaceText;
			},
			getExtension(filename) {
				if (filename != undefined && filename.length > 0) {
					var parts = filename.split('.');
					return parts[parts.length - 1];
				} else {
					return '';
				}
			},

			async onFileSelected(event) {
				var $self = this;
				$self.selectedFile = event.target.files[0];
				// console.log($self.selectedFile.name)
				let typeFile = $self.getExtension($self.selectedFile.name);
				// let exclusionType=['exe','bat','msi','bin'] ;
				let exclusionType = ['xlsx', 'xls', 'pdf', 'txt', 'doc', 'docx', 'ppt', 'pptx', 'zip', 'rar','csv','msg'];
				let videoType = ['mp4', 'mpeg', 'x-ms-wmv', 'quicktime', 'wav'];
				let imageType = ['jpeg', 'png', 'jpeg', 'jpg'];
				let type = '';
				let extension = typeFile;
				var d = new Date();
				if (videoType.includes(typeFile)) {
					typeFile = 'video';
					type = 'video';
				}
				if (imageType.includes(typeFile)) {
					typeFile = 'image';
					type = 'image';
				}

				if (!exclusionType.includes(typeFile) && type.length == 0) {
					$self.error.title = 'Lỗi';
					$self.error.description = 'File của bạn gửi không hợp lệ.';
					$('#modalStatus').css('opacity', 1);
					$('#modalStatus').css('zIndex', 999999999)
					return false;
				} else {
					type = 'file';
				}
				if ($self.selectedFile.size <= 1024 * 1024 * 25) {
					$self.msg_idAddFile = '';
					let files = $('#FileSelectedValue')[0].files;
					let newObjectUrl = URL.createObjectURL(files[0]);
					// console.log(newObjectUrl)
					const formdata = new FormData();

					formdata.append('file', $self.selectedFile, $self.selectedFile.name);
					$self.keyAddFile = $self.messages.length;
					var msg_id = $self.uid();
					$self.msg_idAddFile = msg_id;
					let attachments = [];
					let attachments_data = {
						'extension': extension,
						'file_size': $self.selectedFile.size,
						'mimetype': $self.selectedFile.type,
						'raw_file_name': $self.selectedFile.name,
						'type': type,
						'title': $self.selectedFile.name,
						'url': newObjectUrl
					};
					attachments.push(attachments_data);
					$self.messages.push({
						id: "",
						attachments: attachments,
						msg_id: msg_id,
						type: "text",
						is_rated: 0,
						profile_pic: "",
						rating_recommend: "",
						rating_star: 0,
						text: '',
						url: '',
						name: window.user.name,
						user_id: $self.st_token,
						date_added: Math.floor(Date.now() / 1000),
						date: d.getHours() + ":" + d.getMinutes()
					});
					$self.scrollToEnd();
					// console.log($self.messages)
					// .file_pdf_progress.progress
					// formdata.append('a', {page_id: livechat.getId()})
					// formdata.append('data', {
					//   page_id: livechat.getId(),
					//   text: $self.selectedFile.name,
					//   sender_id: $self.st_token,
					//   name: window.user.name,
					//   survey_data: {
					//     name:window.user.name,
					//     phone:window.user.phone,
					//     email:window.user.email,
					//     address:window.user.address
					//   },
					//   properties:window.user.properties
					// }/*this.selectedFile,this.selectedFile.name*/);
					await axios.post('/app/v1/public/upload/image', formdata, {
						params: {
							page_id: livechat.getId(),
							msg_id: msg_id,
							text: $self.selectedFile.name,
							sender_id: $self.st_token,
							name: window.user.name,
							survey_data: {
								name: window.user.name,
								phone: window.user.phone,
								email: window.user.email,
								address: window.user.address
							},
							properties: window.user.properties
						},
						headers: {
							"Content-Type": "multipart/form-data",
						},
					})
						.then(function (response) {
							/*socket.emit('SEND_IMG' ,{
								page_id: livechat.getId(),
								text: $self.selectedFile.name,
								url: response.data.content,
								sender_id: $self.st_token,
								name: window.user.name,
								survey_data: {
								name:window.user.name,
								phone:window.user.phone,
								email:window.user.email,
								address:window.user.address
								},
								properties:window.user.properties
							});*/
							$("#FileSelectedValue").val('');
							if (response.data.status == 0) {
								$self.messages.splice($self.keyAddFile, 1);
								$self.keyAddFile = 0;
								$self.msg_idAddFile = '';
								$self.error.title = 'Error!';
								$self.error.description = response.data.error;
								$('#modalStatus').css('opacity', 1);
								$('#modalStatus').css('zIndex', 999999999)
							}
							else {
								$self.keyAddFileSuccess = $self.keyAddFile;
								$self.keyAddFile = 0;
							}
						})
						.catch(function (error) {
							console.log(error.data);
							// console.log(error);
						})
				}
				else {
					$self.error.title = 'Lỗi';
					$self.error.description = 'Dung lượng file không được quá 25MB';
					$('#modalStatus').css('opacity', 1);
					$('#modalStatus').css('zIndex', 999999999)
				}
			},
			upload_file: function ($event) {
				var $self = this;
				if($self.disable_button==1){
					return false;
				}
				var elem = this.$refs.fileImage
				elem.click()
				const formdata = new FormData();
				formdata.append('file', this.selectedFile);
			},
			async upload_file_audio($event) {

				var self = this;
				self.loadding = 1;
				self.message_input = ' ';
				var msg_id = self.uid();
				var d = new Date();
				const formData = new FormData();
				formData.append('audio', self.blobData, 'audio.wav');
				axios.post('/app/v1/public/v3/updateAudio', formData, {
					params: {
						page_id: livechat.getId(),
						msg_id: msg_id,
						sender_id: self.st_token,
						name: window.user.name,
						survey_data: {
							name: window.user.name,
							phone: window.user.phone,
							email: window.user.email,
							address: window.user.address
						},
						properties: window.user.properties
					},
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
					.then(function (response) {
						if (response.data.status == 1) {
							let data = response.data.data;
							// self.message_input = response.data.mini;
							let attachments = [];
							let attachments_data = {
								'extension': data.extension,
								'file_size': data.file_size,
								'mimetype': data.mimetype,
								'raw_file_name': data.save_file_name,
								'type': 'audio',
								'title': data.save_file_name,
								'url': data.url
							};
							attachments.push(attachments_data);
							self.messages.push({
								id: "",
								attachments: attachments,
								msg_id: msg_id,
								type: "text",
								is_rated: 0,
								profile_pic: "",
								rating_recommend: "",
								rating_star: 0,
								text: '',
								url: '',
								name: window.user.name,
								user_id: self.st_token,
								date_added: Math.floor(Date.now() / 1000),
								date: d.getHours() + ":" + d.getMinutes()
							});
							self.scrollToEnd();
						} else {
							console.log(response.data);
							// _vmChat.test123=JSON.stringify(response.data);
						}
						// self.message_input ='';
						self.loadding = 0;
					}).catch(function (jqXHR, textStatus, errorThrown) {
						console.log(textStatus + ": " + jqXHR.status + " " + errorThrown);
					});
			},
			generate_uuid4: function (e) {
				var dt = new Date().getTime();
				var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = (dt + Math.random() * 16) % 16 | 0;
					dt = Math.floor(dt / 16);
					return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
				});
				return uuid;
			},
			enter_chat(e) {
				var $self = this;
				if($self.disable_button==1){
					return false;
				}
				if (!$self.st_token) {
					$self.$store.commit('set_token', $self.generate_uuid4());
					livechat.addSetttinglocalStorage(livechat.getId() + '_omnichat', 'st_token', $self.st_token);
					$self.poll();
					$self.polln();
				}
				if ($self.messageInputLength < 1024) {
					this.show_suggest = false;
					this.$refs.input_chat.style.height = '28px';
					var text = this.message_input.trim();
					var msg_id = $self.uid();
					var d = new Date();
					window.clearTimeout(this.timer);
					//gởi tin nhắn
					var text_trim = text.trim();
					if (text_trim == '' || text_trim === null) {
						$self.message_input = '';
						// return false;
					} else {
						$self.messages.push({
							id: "",
							msg_id: msg_id,
							trigger: "message",
							source: "livechat",
							type: "text",
							text: $self.escapeHtml(text),
							user_id: $self.st_token,
							date_added: Math.floor(Date.now() / 1000),
							date: d.getHours() + ":" + d.getMinutes()
						});

						$self.sendMessage(text, msg_id);

						$self.message_input = '';


						$self.scrollToEnd();
						// return false;
					}
				}
				if ($self.images.length) {
                    var files = [];
                    $.each($self.images, function (key, value) {
                        var type = value.split(';')[0].split(':')[1];
                        var extension = value.split(';')[0].split('/')[1];
                        var byteString = atob(value.split(',')[1]);
                        var ab = new ArrayBuffer(byteString.length);
                        var ia = new Uint8Array(ab);
                        for (var i = 0; i < byteString.length; i++) {
                            ia[i] = byteString.charCodeAt(i);
                        }
                        var blob = new Blob([ab], {
                            type: type
                        });
                        var file = new File([blob], "img." + extension, {
                            type: type,
                            lastModified: new Date().getTime()
                        });
                        files.push(file);
                    });
                    $self.push_image(files);
                }
			},
			push_image: function (files) {
                var self = this;

                $.each(files, async function (index, file) {
                    var room_id = self.room_id;
                    var fd = new FormData();
					var d = new Date();

                    fd.append('file', file, file.name)
                    fd.append('private_message', self.private_mes);

                    var extension = self.getExtension(file.name)

                    var newObjectUrl = URL.createObjectURL(file);
                    var index = self.messages.length;

					self.msg_idAddFile = '';
					self.keyAddFile = self.messages.length;
					var msg_id = self.uid();
					self.msg_idAddFile = msg_id;

					let attachments = [];
					let attachments_data = {
						'extension': extension,
						'file_size': file.size,
						'mimetype': file.type,
						'raw_file_name': file.name,
						'type': 'image',
						'title': file.name,
						'url': newObjectUrl
					};
					attachments.push(attachments_data);
					self.messages.push({
						id: "",
						attachments: attachments,
						msg_id: msg_id,
						type: "text",
						is_rated: 0,
						profile_pic: "",
						rating_recommend: "",
						rating_star: 0,
						text: '',
						url: '',
						name: window.user.name,
						user_id: self.st_token,
						date_added: Math.floor(Date.now() / 1000),
						date: d.getHours() + ":" + d.getMinutes()
					});
					self.scrollToEnd();

                    if (file.size <= 1024 * 1024 * 25) {
                        await axios.post('/app/v1/public/upload/image', fd, {
							params: {
								page_id: livechat.getId(),
								msg_id: msg_id,
								text: file.name,
								sender_id: self.st_token,
								name: window.user.name,
								survey_data: {
									name: window.user.name,
									phone: window.user.phone,
									email: window.user.email,
									address: window.user.address
								},
								properties: window.user.properties
							},
							headers: {
								"Content-Type": "multipart/form-data",
							},
						})
						.then(function (response) {
							if (response.data.status == 0) {
								self.messages.splice(self.keyAddFile, 1);
								self.keyAddFile = 0;
								self.msg_idAddFile = '';
								self.error.title = 'Error!';
								self.error.description = response.data.error;
								$('#modalStatus').css('opacity', 1);
								$('#modalStatus').css('zIndex', 999999999)
							}
							else {
								self.keyAddFileSuccess = self.keyAddFile;
								self.keyAddFile = 0;
							}
						})
						.catch(function (error) {
							console.log(error.data);
							// console.log(error);
						})
                    } else {
                        Swal.fire({
                            type: 'error',
                            title: 'File ' + file.name + ' lớn hơn 20MB. </br>Vui lòng gởi file nhẹ hơn',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }

                })
                self.images = [];
            },
			sendMessage: function (text, msg_id = '') {
				var $self = this;
				axios.post('/app/v1/public/SEND_MESSAGE', {
					page_id: livechat.getId(),
					msg_id: msg_id,
					text: text,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
					survey_data: {
						name: window.user.name,
						phone: window.user.phone,
						email: window.user.email,
						address: window.user.address
					},
					properties: window.user.properties
				}).then((response) => {
					if (response.data.status == 1) {
					}
					if (response.data.show_typing) {
						if ($self.page.parent_user == 'C1184') {
							window.setTimeout(() => {
								$self.set_show_typing(1, 3);
							}, 800);
						}
						else {
							window.setTimeout(() => {
								$self.set_show_typing(1, 10);
							}, 300);
						}
					}
				}).catch(error => {
					console.log(error);
				});
			},
			handleKeyUp(e) {
				if (e.keyCode === 13) {
				} else {
					window.clearTimeout(this.timer); // prevent errant multiple timeouts from being generated
					this.timer = window.setTimeout(() => {
						var $self = this;
						$self.getSuggestions();
					}, this.timeoutVal);
				}
			},
			set_show_typing(show_typing, seconds = 3) {
				var $self = this;
				$self.show_typing = show_typing;
				window.clearTimeout(this.timer_show_typing); // prevent errant multiple timeouts from being generated

				if (show_typing) {
					var lastmessforagent = $self.messages[$self.messages.length - 2];
					var lastMes = $self.messages[$self.messages.length - 1];
					if (lastMes.user_id != $self.st_token) { //neu ko phải do page nhắn mà do user nào dc assign
						$self.set_show_typing(0);
					}
					else {
						this.timer_show_typing = window.setTimeout(() => {
							// var $self = this;
							$self.set_show_typing(0);
						}, seconds * 1000);
					}
				}
			},
			getLocation(message_id) {
				var $self = this;
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (position) {
						// Retrieve the latitude and longitude
						var latitude = position.coords.latitude;
						var longitude = position.coords.longitude;

						// Do something with the coordinates, e.g., display them on the webpage
						return { latitude: latitude, longitude: longitude }
					}, function (error) {
						// Handle any errors that occur during geolocation
						switch (error.code) {
							case error.PERMISSION_DENIED:
								console.error("User denied the request for geolocation.");
								break;
							case error.POSITION_UNAVAILABLE:
								console.error("Location information is unavailable.");
								break;
							case error.TIMEOUT:
								console.error("The request to get user location timed out.");
								break;
							case error.UNKNOWN_ERROR:
								console.error("An unknown error occurred.");
								break;
						}
					});

				} else {
					return "Geolocation is not supported by this browser.";
				}
			},
			// showPosition(position) {

			// 	return {latitude: position.coords.latitude,longitude:position.coords.longitude}
			// },
			send_postback(message_id, payload, title, type) {
				var $self = this;
				var msg_id = $self.uid();
				var d = new Date();

				$self.messages.push({
					id: "",
					msg_id: msg_id,
					trigger: "message",
					source: "livechat",
					type: "text",
					text: title,
					user_id: $self.st_token,
					date_added: Math.floor(Date.now() / 1000),
					date: d.getHours() + ":" + d.getMinutes()
				});
				let location = [];
				if (type == 'location') {
					if (navigator.geolocation) {
						navigator.geolocation.getCurrentPosition(function (position) {
							// Retrieve the latitude and longitude
							var latitude = position.coords.latitude;
							var longitude = position.coords.longitude;

							// Do something with the coordinates, e.g., display them on the webpage
							location = { latitude: latitude, longitude: longitude };
							axios.post('/app/v1/public/SEND_POSTBACK', {
								page_id: livechat.getId(),
								msg_id: msg_id,
								sender_id: $self.st_token,
								name: window.user.name,
								windowInfo: livechat.windowInfo,
								survey_data: {
									name: window.user.name,
									phone: window.user.phone,
									email: window.user.email,
									address: window.user.address
								},
								postback: {
									message_id: message_id,
									// index: index,
									payload: payload,
									title: title,
									type: type,
									location: location
								},

								properties: window.user.properties
							}).then((response) => {
								if (response.data.show_typing) {
									window.setTimeout(() => {
										$self.set_show_typing(1, 10);
									}, 300);

								}
							}).catch(error => {
								console.log(error);
							});
						}, function (error) {
							// Handle any errors that occur during geolocation
							switch (error.code) {
								case error.PERMISSION_DENIED:
									location = { 'error': 1, 'message': 'User denied the request for geolocation.' }
									break;
								case error.POSITION_UNAVAILABLE:
									location = { 'error': 1, 'message': 'Location information is unavailable.' }
									break;
								case error.TIMEOUT:
									location = { 'error': 1, 'message': 'The request to get user location timed out.' }
									break;
								case error.UNKNOWN_ERROR:
									location = { 'error': 1, 'message': 'An unknown error occurred.' }
									break;
							}
							axios.post('/app/v1/public/SEND_POSTBACK', {
								page_id: livechat.getId(),
								msg_id: msg_id,
								sender_id: $self.st_token,
								name: window.user.name,
								windowInfo: livechat.windowInfo,
								survey_data: {
									name: window.user.name,
									phone: window.user.phone,
									email: window.user.email,
									address: window.user.address
								},
								postback: {
									message_id: message_id,
									// index: index,
									payload: payload,
									title: title,
									type: type,
									location: location
								},

								properties: window.user.properties
							}).then((response) => {
								if (response.data.show_typing) {
									window.setTimeout(() => {
										$self.set_show_typing(1, 10);
									}, 300);

								}
							}).catch(error => {
								console.log(error);
							});
						});

					} else {
						location = { 'error': 1, 'message': 'Geolocation is not supported by this browser.' }
						axios.post('/app/v1/public/SEND_POSTBACK', {
							page_id: livechat.getId(),
							msg_id: msg_id,
							sender_id: $self.st_token,
							name: window.user.name,
							windowInfo: livechat.windowInfo,
							survey_data: {
								name: window.user.name,
								phone: window.user.phone,
								email: window.user.email,
								address: window.user.address
							},
							postback: {
								message_id: message_id,
								// index: index,
								payload: payload,
								title: title,
								type: type,
								location: location
							},

							properties: window.user.properties
						}).then((response) => {
							if (response.data.show_typing) {
								window.setTimeout(() => {
									$self.set_show_typing(1, 10);
								}, 300);

							}
						}).catch(error => {
							console.log(error);
						});
					}



				} else {
					axios.post('/app/v1/public/SEND_POSTBACK', {
						page_id: livechat.getId(),
						msg_id: msg_id,
						sender_id: $self.st_token,
						name: window.user.name,
						windowInfo: livechat.windowInfo,
						survey_data: {
							name: window.user.name,
							phone: window.user.phone,
							email: window.user.email,
							address: window.user.address
						},
						postback: {
							message_id: message_id,
							// index: index,
							payload: payload,
							title: title,
							type: type,
						},

						properties: window.user.properties
					}).then((response) => {
						if (response.data.show_typing) {
							window.setTimeout(() => {
								$self.set_show_typing(1, 10);
							}, 300);
						}
					}).catch(error => {
						console.log(error);
					});
				}

			},
			clickMenu(payload, title) {
				var $self = this;
				$self.show_menu = false;
				$self.show_suggest = false;
				var msgID = $self.uid();
				var d = new Date();
				this.messages.push({
					id: "",
					msg_id: msgID,
					trigger: "message",
					source: "livechat",
					type: "text",
					text: title,
					user_id: this.st_token,
					date_added: Math.floor(Date.now() / 1000),
					date: d.getHours() + ":" + d.getMinutes()
				});

				axios.post('/app/v1/public/SEND_POSTBACK', {
					page_id: livechat.getId(),
					msg_id: msgID,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
					survey_data: {
						name: window.user.name,
						phone: window.user.phone,
						email: window.user.email,
						address: window.user.address
					},
					postback: {
						payload: payload,
						title: title,
					},
					// properties:window.user.properties
				}).then((response) => {
					if (response.data.status == 1) {

					}
				}).catch(error => {
					console.log(error);
				});
			},
			minimize: function () {
				$('.h-btn').removeClass('zoomOut');
				$('.hotline-launcher').hide();
				this.new_message_number = 0;
				this.$emit('new_message_number', 0);
				top.postMessage({ st_popup_status: 0 }, document.referrer);
				// this.show_launcher = 0;
				this.$store.commit('set_show_launcher', 0);
			},
			reload_iframe: function () {
				var $self = this;
				/*socket.emit('LEAVE_CONVERSATION' ,{
				  page_id: livechat.getId(),
				  sender_id: $self.st_token,
				  name: window.user.name,
				  windowInfo:livechat.windowInfo,
				  survey_data: {
					name:window.user.name,
					phone:window.user.phone,
					email:window.user.email,
					address:window.user.address
				  },
				  properties:window.user.properties
				});*/

				axios.post('/app/v1/public/LEAVE_CONVERSATION', {
					page_id: livechat.getId(),
					msg_id: $self.uid(),
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
					survey_data: {
						name: window.user.name,
						phone: window.user.phone,
						email: window.user.email,
						address: window.user.address
					},
					properties: window.user.properties
				}).then((response) => {
					if (response.data.status == 1) {
						var data = response.data.data;
						setTimeout(function () {
							if ($self.lsTest() === true) {
								localStorage.clear();
							}
							top.postMessage({ reload_iframe: true }, document.referrer);
							$self.$store.commit('set_token', '');
							// socket.emit('load1',null);
							$self.refresh_token();

							$self.minimize();
						}, 150);
					}
				}).catch(error => {
					console.log(error);
				});

				$self.reload_iframe_click = 0
			},
			lsTest() {
				var test = 'test';
				try {
					localStorage.setItem(test, test);
					localStorage.removeItem(test);
					return true;
				} catch (e) {
					return false;
				}
			},
			uid() {
				return (performance.now().toString(36) + Math.random().toString(36)).replace(/\./g, "");
			},
			isMobile() {
				/* Storing user's device details in a variable*/
				let details = navigator.userAgent;

				/* Creating a regular expression
				containing some mobile devices keywords
				to search it in details string*/
				let regexp = /android|iphone|kindle|ipad/i;

				/* Using test() method to search regexp in details
				it returns boolean value*/
				let isMobileDevice = regexp.test(details);

				if (isMobileDevice) {
					return true;
				} else {
					return false;
				}
			},
			download_msg_txt: function () {
				var $self = this;
				var text = '';
				this.messages.forEach(function (message, index) {
					if (message.user_id != $self.st_token) {
						text += "USER: ";
					} else {
						text += "AGENT: ";
					}
					if (message.text != '') {
						text += message.text + "\n";
					}

				});
				var filename = 'chat_transcript';

				var element = document.createElement('a');
				element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
				element.setAttribute('download', filename);
				element.style.display = 'none';
				document.body.appendChild(element);
				element.click();
				document.body.removeChild(element);

			},
			refresh_token() {
				var $self = this;
				axios.get('/app/v1/public/load/').then((response) => {
					if (response.data.status == 1) {
						var st_token = response.data.st_token;
						livechat.addSetttinglocalStorage(livechat.getId() + '_omnichat', 'st_token', st_token);
						$self.st_token = st_token;
					}
				}).catch(error => {
					console.log(error);
				});
			},
			playSound(sound) {
				if (sound) {
					var audio = new Audio(sound);
					audio.volume = 0.4;
					audio.play();
				}
			},
			toggle_widget_setting: function () {
				$('.widget-setting-dropdown').toggleClass('visible');
			},
			scrollToEnd: function () {
				var $self = this;
				setTimeout(function () {
					$self.insertDateLine();
				}, 150);
				setTimeout(function () {
					var $chat_content = $(document).find('.chat-content');
					var chatbox = $(document).find('.chatbox');
					chatbox.scrollTop($chat_content.height() + 99999);
				}, 250);
			},
			insertDateLine: function () {
				var $self = this;
				var date_array = [];
				$(document).find('.chatbox .chat-date-separator').remove();
				$(document).find('.chatbox .chat-message-main').each(function (index, value) {
					var timestamp = $(this).find('.chat-message-date').attr('data-time');
					if(timestamp != undefined){
						var d = new Date(timestamp * 1000);
						var curr_date = d.getDate();
						var curr_month = d.getMonth() + 1;
						var curr_year = d.getFullYear();
						var date = curr_date + '/' + curr_month + '/' + curr_year;
						if ($.inArray(date, date_array) >= 0) {

						} else {
							date_array.push(date);
							date = $self.MDFormat(curr_year + '-' + curr_month + '-' + curr_date);
							$('<div class="chat-date-separator"><span>' + date + '</span></div>').insertBefore($(this));
						}
					}

				});
			},
			MDFormat: function (MMDD) {
				var $self = this;
				MMDD = new Date(MMDD.replace(/-/g, "/"));
				var vn_mths = ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"];
				var en_mths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
				var mths = '';
				if ($self.$i18n.locale == 'vi') mths = vn_mths;
				else mths = en_mths;
				var strDate = "";

				var tday = new Date();
				tday.setHours(0, 0, 0, 0);

				var yterday = new Date();
				yterday.setHours(0, 0, 0, 0);
				yterday.setDate(yterday.getDate() - 1);

				var tmrw = new Date();
				tmrw.setHours(0, 0, 0, 0);
				tmrw.setDate(tmrw.getDate() + 1);

				if (tday.getTime() == MMDD.getTime()) {
					strDate = /*'Hôm nay';*/$self.$t('today');
				} else if (yterday.getTime() == MMDD.getTime()) {
					strDate = $self.$t('yesterday');//"Hôm qua";
				} else if (tmrw.getTime() == MMDD.getTime()) {
					strDate = $self.$t('tomorrow');
				} else {
					strDate = MMDD.getDate() + " " + mths[MMDD.getMonth()] + " " + MMDD.getFullYear();
				}

				return strDate;
			},
			showNotification: function (title, text, icon = this.page.button) {
				var hasFocus = this.hasFocus;
				if (window.Notification && !hasFocus) {
					if (Notification.permission === "granted") {
						text = text.replace('<br>', '');
						text = text.substring(0, 20);
						var n = new Notification(title, { body: text, icon: icon });
						setTimeout(n.close.bind(n), 5000);
						// };
					} else {
						console.log('Your browser doesn\'t support notifications.');
					}
				}
			},
			setLang: function (event) {
				var $self = this;
				var val = event.target.value;
				this.setting_language = val;
				window.livechat.setSettingLanguage(val);
				this.$store.commit('set_lang', val);
				$self.$i18n.locale = val;

				//send event
				axios.post('/app/v1/public/CHANGE_LANGUAGE', {
					page_id: livechat.getId(),
					msg_id: $self.uid(),
					language: val,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
				}).then((response) => {
				}).catch(error => {
					console.log(error);
				});
			},
			setLangNotificationEvent: function (val) {
				window.livechat.setSettingLanguage(val);
				this.$store.commit('set_lang', val);
				$self.$i18n.locale = val;

				//send event
				axios.post('/app/v1/public/CHANGE_LANGUAGE', {
					page_id: livechat.getId(),
					msg_id: $self.uid(),
					language: val,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
				}).then((response) => {
				}).catch(error => {
					console.log(error);
				});
			},
			detectURL: function (message) {
				if (!message) return;

				var newMessage = this.restoreHtmlTag(message);

				if (newMessage.startsWith("<a") && newMessage.endsWith("</a>")) return newMessage;

				var exp = /(\b(https?|ftps?|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
				if (exp.test(message)) {
					var finalText = message.replace(exp, "<a href='$1' target='_blank'>$1</a>");
				}
				else {
					var urlPattern = /\b(?:https?|ftps?):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
					var pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
					var emailAddressPattern = /(([a-zA-Z0-9_\-\.]+)@[a-zA-Z_]+?(?:\.[a-zA-Z]{2,6}))+/gim;
					var phoneNumberPattern = /^[+ -](\+?1\s*[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4} /gim;
					var finalText = message
						.replace(urlPattern, '<a target="_blank" href="$&">$&</a>')
						.replace(pseudoUrlPattern, '$1<a target="_blank" href="http://$2">$2</a>')
						.replace(emailAddressPattern, '<a target="_blank" href="mailto:$1">$1</a>')
						.replace(phoneNumberPattern, '<a href="javascript:void(0)" class="click-phone" data-phone="$&">$&</a>');
				}
				return this.restoreHtmlTag(finalText);
			},
			escapeHtml: function (text) {
				return text
					.replace(/&/g, "&amp;")
					.replace(/</g, "&lt;")
					.replace(/>/g, "&gt;")
					.replace(/"/g, "&quot;")
					.replace(/'/g, "&#039;");
			},
			restoreHtmlTag: function (text) {
				return text
					.replace(/&amp;/g, "&")
					.replace(/&lt;/g, "<")
					.replace(/&gt;/g, ">")
					.replace(/&quot;/g, '"')
					.replace(/&#039;/g, "'");
			},
			changePrev: function (index_message) {
				var el = $('#slides__' + index_message);
				var countElement = el.attr('data-elements');
				var slideElement = el.parent();

				if (!this.slideIndexes[index_message]) var currentSlide = 0;
				else var currentSlide = this.slideIndexes[index_message];

				if (currentSlide == 0) {
					currentSlide = countElement - 1;
					var prevSlide = currentSlide - 1;
					var nextSlide = 0;
				}
				else {
					currentSlide = currentSlide - 1;
					if (currentSlide != 0) var prevSlide = currentSlide - 1;
					else var prevSlide = countElement - 1;
					var nextSlide = currentSlide + 1;
				}

				var offsetLeft = $('#slide__' + index_message + '_' + currentSlide).width();
				$('.slide__dot').removeClass('slick-active');
				$('.slick-dots li.slide__' + index_message + '_' + currentSlide).addClass('slick-active');
				// class="slide__dot" :class="(index==0)?'slick-active slide__' + index_message + '_' + index:'slide__' + index_message + '_' + index"
				el.scrollLeft(currentSlide * offsetLeft);

				this.slideIndexes[index_message] = currentSlide;
				var newHrefPrev = '#slide__' + index_message + '_' + prevSlide;
				var newHrefNext = '#slide__' + index_message + '_' + nextSlide;

				setTimeout(function () {
					$('#slide__prev_' + index_message).attr('href', newHrefPrev);
					$('#slide__next_' + index_message).attr('href', newHrefNext);
				}, 500)
			},
			changeNext: function (index_message) {
				var el = $('#slides__' + index_message);
				var countElement = el.attr('data-elements');
				if (!this.slideIndexes[index_message]) var currentSlide = 0;
				else var currentSlide = this.slideIndexes[index_message];
				if (currentSlide == countElement - 1) {
					currentSlide = 0;
					var prevSlide = countElement - 1;
					var nextSlide = currentSlide + 1;
				}
				else {
					currentSlide = currentSlide + 1;
					if (currentSlide == countElement - 1) var nextSlide = 0;
					else var nextSlide = currentSlide + 1;
					var prevSlide = currentSlide - 1;
				}

				var offsetLeft = $('#slide__' + index_message + '_' + currentSlide).width();
				$('.slide__dot').removeClass('slick-active');
				$('.slick-dots li.slide__' + index_message + '_' + currentSlide).addClass('slick-active');
				el.scrollLeft(currentSlide * offsetLeft);

				this.slideIndexes[index_message] = currentSlide;
				var newHrefPrev = '#slide__' + index_message + '_' + prevSlide;
				var newHrefNext = '#slide__' + index_message + '_' + nextSlide;
				setTimeout(function () {
					$('#slide__prev_' + index_message).attr('href', newHrefPrev);
					$('#slide__next_' + index_message).attr('href', newHrefNext);
				}, 500)
			},

			openFormRating: function (message) {
				this.$store.commit('show_rating', true);
				this.customerFeedbackConfig = message.attachments.payload.feedback_screens[0].questions[0];
				this.customerFeedbackConfig.message_id = message.id
				this.customerFeedbackConfig.language = message.language != undefined ? message.language : 'en';
			},
			closeFormRating: function (dataEmit) {
				if (dataEmit.message_id != undefined) {
					var indexMes = this.messages.findIndex(mes => mes.id == dataEmit.message_id);
					if (indexMes != -1) {
						var mes = this.messages[indexMes];
						mes.is_rated = 1;
						mes.rating_star = dataEmit.rating_star;
						mes.rating_recommend = dataEmit.rating_recommend;
						this.messages.splice(indexMes, 1, mes);
					}
				}
				this.$store.commit('show_rating', false);
			},
			isHiddenName: function (keyMessage) {
				if (keyMessage == 0) return false;
				return this.messages[keyMessage].user_id == this.messages[keyMessage - 1].user_id &&
					this.messages[keyMessage].name == this.messages[keyMessage - 1].name
			},
			isHiddenTime: function (keyMessage) {
				if (this.messages[keyMessage + 1] == undefined) return false;
				return this.messages[keyMessage].user_id == this.messages[keyMessage + 1].user_id &&
					this.messages[keyMessage].name == this.messages[keyMessage + 1].name
			},
			closeModal: function () {
				$('#modalStatus').css('opacity', 0);
				$('#modalStatus').css('zIndex', -1);
			},
			closePhoneModal: function () {
				$('#modal-phonenumber').css('opacity', 0);
				$('#modal-phonenumber').css('zIndex', -1);
			},
			async copyPhoneNumber() {
				var _vmChat = this;
				try {
					const clipboardData =
						event.clipboardData ||
						window.clipboardData ||
						event.originalEvent?.clipboardData ||
						navigator.clipboard;

					clipboardData.writeText(_vmChat.phoneNumber);
					$('#modal-phonenumber').css('opacity', 0);
					$('#modal-phonenumber').css('zIndex', -1);
				} catch ($e) {
					console.log($e);
				}
			},
			getwindowInfo(filename) {
				let _vm = this;
				let windowInfo = localStorage.getItem("windowInfo");
				windowInfo = JSON.parse(windowInfo);
				if (typeof windowInfo == 'object' && windowInfo != null) {
					// console.log(windowInfo)
					// console.log( typeof windowInfo)
					if (Object.keys(windowInfo).length > 0) {
						let path = window.location.pathname;

						var index = windowInfo.findIndex(url => url.session_url == path);
						if (index != -1) {
							windowInfo = windowInfo[index];
						}
					} else {
						return false
					}
				} else {
					return false
				}

				// console.log('hieu');
				// console.log(windowInfo);
				// console.log(typeof windowInfo);
				let callWebhook = 0;
				if ((windowInfo.session_url != _vm.session_url || windowInfo.session_starttime != _vm.session_starttime)) {
					callWebhook = 1;
					_vm.session_url = windowInfo.session_url;
					_vm.session_starttime = windowInfo.session_starttime;
				} else if (windowInfo.interaction != undefined) {
					if (windowInfo.interaction.interaction_click != _vm.interaction_click || windowInfo.interaction.interaction_view != _vm.interaction_view || windowInfo.interaction.exact_interaction_click != _vm.exact_interaction_click) {
						callWebhook = 1;
						_vm.interaction_click = windowInfo.interaction.interaction_click;
						_vm.interaction_view = windowInfo.interaction.interaction_view;
						_vm.exact_interaction_click = windowInfo.interaction.exact_interaction_click;

					} else if (windowInfo.interaction.form_interaction_submit != _vm.form_interaction_submit && windowInfo.interaction.interaction_scroll != _vm.interaction_scroll) {
						callWebhook = 1;
						_vm.form_interaction_submit = windowInfo.interaction.form_interaction_submit;
						_vm.interaction_scroll = windowInfo.interaction.interaction_scroll;
					}
				}

				if (callWebhook == 1 && _vm.$store.state.st_token != undefined) {

					axios.post('/app/v1/public/windowInfo', {
						windowInfo: windowInfo,
						page_id: livechat.getId(),
						sender_id: _vm.st_token,
						name: window.user.name,
						survey_data: {
							name: window.user.name,
							phone: window.user.phone,
							email: window.user.email,
							address: window.user.address
						},
						properties: window.user.properties
					}).then((response) => {
					}).catch(error => {
						console.log(error);
					});
				}
			},
			reloaddata() {
				let _vm = this;
				let windowInfo = localStorage.getItem("windowInfo");
				if (_vm.reloadinterval === 0) {
					var windowInfoData = setInterval(_vm.getwindowInfo, 20000);
				}
				if (_vm.reloadinterval === 1) {
					clearInterval(windowInfoData);
				}
			},
			getSuggestions: function () {
				var $self = this;
				axios.post('/app/v1/public/TYPING', {
					page_id: livechat.getId(),
					text: $self.message_input,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
					survey_data: {
						name: window.user.name,
						phone: window.user.phone,
						email: window.user.email,
						address: window.user.address
					},
					properties: window.user.properties
				}).then((response) => {
					if (response.data.suggestions != undefined && response.data.suggestions.length) {
						$self.suggest_data = response.data.suggestions
						$self.show_suggest = 1;
					}
					else $self.show_suggest = 0;
				}).catch(error => {
					console.log(error);
				});
			},
			sendSuggestion: function (suggestion) {
				var msg_id = this.uid();
				if (suggestion.type == 'postback') {
					this.clickMenu(suggestion.payload, suggestion.text);
				}
				else {
					this.sendMessage(suggestion.text, msg_id);
				}
				this.message_input = '';
				this.show_suggest = 0;
			},
			sendDeliveredEvent: function (message) {
				var $self = this;
				axios.post('/app/v1/public/msg_delivered', {
					sender_id: message.user_id,
					recipient_id: $self.st_token,
					message_id: message.id,
					message_app_id: message.msg_id,
				}).then((response) => {
					// 	if (response.data.suggestions != undefined && response.data.suggestions.length) {
					// 		$self.suggest_data = response.data.suggestions
					// 		$self.show_suggest = 1;
					// 	}
					// 	else $self.show_suggest = 0;
					// }).catch(error => {
					// 	console.log(error);
				});
			},
			setUnsendMessage: function(message){
				var index = this.messages.findIndex(currentMessage => currentMessage.id === message.message_id);
				if (index >= 0) {
					var currentMessage = this.messages[index];
					currentMessage.unsend = 1
					this.messages.splice(index, 1, currentMessage);
				}
			},
			setEditMessage: function(message){
				let _vm=this;
				var index = this.messages.findIndex(currentMessage => currentMessage.id === message.message_id);
				if (index >= 0) {
					var currentMessage = _vm.messages[index];
					currentMessage.text=message.message;
					_vm.messages.splice(index, 1, currentMessage);
				}
			},
			onPaste: function (evt) {
                var vm_msg = this;
                const items = (evt.clipboardData || evt.originalEvent.clipboardData).items;
                var blob = null;
                for (const item of items) {
                    if (item.type.indexOf('image') === 0) {
                        blob = item.getAsFile();
                    }
                }
                if (blob !== null) {
                    const reader = new FileReader();
                    reader.onload = (evt) => {
                        vm_msg.images.push(evt.target.result);
                    };
                    reader.readAsDataURL(blob);
                }
                return true;
            },
			removeImage: function (index) {
                this.images.splice(index, 1);
            },
			sortMessages: function(){
				this.messages.sort(function sortMessgeBySentTime(message1, message2){
					return message1.sent_time - message2.sent_time
				})
			}
		},
		beforeDestroy() {
			this.reloadinterval = 1;
			clearInterval(windowInfoData);
		},
		async mounted() {
			var vm = this;
			var socket = io.connect("https://ws-omni-chat.worldfone.cloud", {
				reconnectionDelayMax: 10000,
				// rejectUnauthorized: false
				"transports": ['websocket']
			});

			socket.on("connect_error", (err) => {
				console.log(`connect_error due to ${err.message}`);
			});

			socket.on('connect_redis', (message) => {
				console.log(message);
			})

			socket.on('disconnect', function () {
				console.log('disconnect');

				var reconnect = setInterval(function() {
					if (!socket.connected) {
						socket.connect();
					} else {
						clearInterval(reconnect);
					}
				}, 4000);
			});

			socket.on("connect_error", (error) => {
				console.log(error.message);
			});

			socket.on('connect', function() {
				var data_init = {
					channel: "livechat_notification_" + vm.st_token,
					time: Date.now()
				};
				// Initialize connection
				socket.emit("init", data_init, (response) => {
					console.log(response);
				});
			});

			socket.on('subscribe_channel', function(message) {
				console.log('Subscribe channel:', message);
			});

			socket.on('pull_msg', function(data) {
				// addMessage("Received: " + JSON.stringify(data));
				// Handle streaming data from Redis
				try {
					// Parse the message data
					let messageData = data.message;
					var msgID = data.msg_id;
					vm.disable_button = 1;
					if (messageData && messageData.text) {
						// Get the text content
						let text = messageData.text;
						var indexMes = vm.messages.findIndex(message => message.msg_id == msgID);
						var d = new Date();
						if(indexMes == -1){
							var newMes = {
								id: "",
								msg_id: msgID,
								trigger: "message",
								source: "livechat",
								type: "text",
								text: vm.escapeHtml(text),
								user_id: vm.page.page_id,
								date_added: Math.floor(Date.now() / 1000),
								date: d.getHours() + ":" + d.getMinutes(),
								name: vm.page.page_info.name,
								profile_pic: vm.page.logo,
							}
							vm.messages.push(newMes);
						}
						else{
							var message = vm.messages[indexMes];
							message.text += text;
							message = Object.assign({}, message, { text: message.text });
							vm.messages.splice(indexMes, 1, message);
						}
						setTimeout(function () {
							vm.scrollToEnd();
							// $self.insertDateLine();
						}, 150);
					}
					else if(data.end_stream){
						vm.disable_button = 0;
					}
					clearTimeout(vm.timeoutId); // Clear the previous timeout
					vm.timeoutId = setTimeout(() => {
						vm.disable_button=0;
					}, 2000);
				} catch (error) {
					console.error('Error processing streaming data:', error);
				}
			});

			socket.on('init_error', function(error) {
				console.error('Initialization error:', error);

			});

			$(document).ready(function () {
				$('textarea#flex_item_right').keypress(function (event) {
					if (event.keyCode == 13) {
						if (event.shiftKey) { }
						else {
							event.preventDefault();
						}
					}
				});
			});
			if (this.page.show_microphone != undefined) {
				this.show_microphone = this.page.show_microphone;
			}
			// var  windowInfoData  = setInterval(_vm.getwindowInfo, 20000);
			if (this.reloadinterval === 0) {
				this.reloaddata();
			}
			// document.getElementsByTagName('head')[0].appendChild( '.chat-content-w .chat-message .reply.active, .chat-content-w .chat-message .reply:hover{ background-color: '+page.color+'}');
			// Get the current page URL

			this.agent = {
				name: this.page.page_info.name,
				avatar: this.page.logo,
			};

			if (!this.isMobile()) {
				if (this.page.parent_user == 'C1184') {
					window.livechat.setSettingNoti(true);
					this.setting_noti = true;
				} else if (Notification.permission === "granted") {
					window.livechat.setSettingNoti(true);
					this.setting_noti = true;
				} else {
					window.livechat.setSettingNoti(false);
				}
			} else {
				window.livechat.setSettingNoti(true);
			}

			// console.log(ENV);
			var $self = this;
			if ($self.st_token) {
				setTimeout(function () {
					$self.get_messages();
				},550);
			}

			$('.chatbox').on('click', '.click-phone', function () {
				var phoneNumber = $(this).attr('data-phone');
				if (phoneNumber) {
					$self.phoneNumber = phoneNumber;
					$('#modal-phonenumber').css('opacity', 1);
					$('#modal-phonenumber').css('zIndex', 999999999);
				}
			})
			localStorage.getItem("lastname");
			$('.microphone').on('click', function () {
				$(this).toggleClass('open')
			})

			// this.getSuggestions();
		},
		watch: {

			/*message_input: function (val) {
				this.mixin_autoResize_resize(this.$refs.input_chat)
			},*/
			show_launcher: function (val) {
				var $self = this;
				if (val == 1) {
					setTimeout(function () {
						$self.scrollToEnd();
						$self.insertDateLine();
					}, 150);
				}
			},
			setting_sound: function (val) {
				window.livechat.setSettingSound(val);
			},
			hasFocus: function (val) {
			},
			/*lang: function(val){
			  // this.setting_language = val;
			  window.livechat.setSettingLanguage(val);
			  this.$store.commit('set_lang', val);
			},*/
			/*setting_noti: function(val){
			  window.livechat.setSettingNoti(val);
			},*/

			show_rating: function (val) {
				var $self = this;
				setTimeout(function () {
					$self.insertDateLine();
				}, 150);
				$self.scrollToEnd();
			},

			/*setting_language: function(val){
			  this.$emit('swithLang', this.setting_language);
			  // var Languages = window.livechat.getLanguages();
			},*/
			agent_id: function (val) {
				var $self = this;
				if (val != '') {
					// socket.emit('get_agent', {st_token:$self.st_token, agent_id: val});
				}
			},
		},

	}

</script>
<style scoped lang="css">
	.disabled-button{position: relative;}
	.disabled-button i,.disabled-button.sendchat_box .sendchat_button{position: relative;}
	.disabled-button i::after,.disabled-button.sendchat_box .sendchat_button::after{position: absolute;content: "";    width: calc(100% + 2px);height: calc(100% + 2px);left: -1px;top: -1px;background-color: rgba(255,255,255,0.7);line-height: 30px;text-align: center;overflow: hidden;}
	.disabled-button.sendchat_box .sendchat_button::after{    content: "\f110";font-weight: 900;font-family: "Font Awesome 5 Free";animation: fa-spin 2s linear infinite;	color: var(--color);border-radius: 50%;}
	.tab-microphone {
		display: inline-table;
		list-style-type: none;
		width: 100%;
		margin: 5px 0;
	}

	.tab-microphone li {
		float: left;
		margin-right: 5px;
	}

	.tab-microphone li a {
		background-color: #e1e1e1;
		padding: 2px 10px;
		border-radius: 5px 5px 0 0;
		cursor: pointer;
	}
	.tab-microphone li:hover a {font-weight: bold;}
	.tab-microphone li.active a
	{
		background-color: var(--color);
		color: #fff;
	}


	/* color button send */
	.coccoc-alo-ph-circle {
		width: 160px;
		height: 160px;
		top: 20px;
		left: 20px;
		position: absolute;
		background-color: transparent;
		-webkit-border-radius: 100%;
		-moz-border-radius: 100%;
		border-radius: 100%;
		border: 2px solid rgba(30, 30, 30, 0.4);
		opacity: .1;
		-webkit-animation: coccoc-alo-circle-anim 1.2s infinite ease-in-out;
		-moz-animation: coccoc-alo-circle-anim 1.2s infinite ease-in-out;
		-ms-animation: coccoc-alo-circle-anim 1.2s infinite ease-in-out;
		-o-animation: coccoc-alo-circle-anim 1.2s infinite ease-in-out;
		animation: coccoc-alo-circle-anim 1.2s infinite ease-in-out;
		-webkit-transition: all .5s;
		-moz-transition: all .5s;
		-o-transition: all .5s;
		transition: all .5s;
	}

	.coccoc-alo-phone {
		background-color: transparent;
		width: 200px;
		height: 200px;
		cursor: pointer;
		margin: 0 auto;
		z-index: 200000 !important;
		-webkit-backface-visibility: hidden;
		-webkit-transform: translateZ(0);
		-webkit-transition: visibility .5s;
		-moz-transition: visibility .5s;
		-o-transition: visibility .5s;
		transition: visibility .5s;
		right: 150px;
		top: 30px;
	}

	.coccoc-alo-phone.coccoc-alo-green .coccoc-alo-ph-circle-fill {
		background-color: var(--color);
		opacity: .75 !important;
	}

	.coccoc-alo-ph-circle-fill {
		width: 100px;
		height: 100px;
		top: 50px;
		left: 50px;
		position: absolute;
		background-color: #000;
		-webkit-border-radius: 100%;
		-moz-border-radius: 100%;
		border-radius: 100%;
		border: 2px solid transparent;
		opacity: .1;
		-webkit-animation: coccoc-alo-circle-fill-anim 2.3s infinite ease-in-out;
		-moz-animation: coccoc-alo-circle-fill-anim 2.3s infinite ease-in-out;
		-ms-animation: coccoc-alo-circle-fill-anim 2.3s infinite ease-in-out;
		-o-animation: coccoc-alo-circle-fill-anim 2.3s infinite ease-in-out;
		animation: coccoc-alo-circle-fill-anim 2.3s infinite ease-in-out;
		-webkit-transition: all .5s;
		-moz-transition: all .5s;
		-o-transition: all .5s;
		transition: all .5s;
	}

	.coccoc-alo-ph-img-circle {
		width: 60px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		color: #fff;
		top: 70px;
		left: 70px;
		position: absolute;
		-webkit-border-radius: 100%;
		-moz-border-radius: 100%;
		border-radius: 100%;
		border: 2px solid transparent;
		opacity: .7;

	}

	.coccoc-alo-phone.coccoc-alo-green .coccoc-alo-ph-img-circle {
		background-color: var(--color);
	}

	.coccoc-alo-phone.coccoc-alo-green .coccoc-alo-ph-circle {
		border-color: var(--color);
		opacity: .5;
	}



	@-moz-keyframes coccoc-alo-circle-anim {
		0% {
			transform: rotate(0) scale(.5) skew(1deg);
			opacity: .1
		}

		30% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .5
		}

		100% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .1
		}
	}

	@-webkit-keyframes coccoc-alo-circle-anim {
		0% {
			transform: rotate(0) scale(.5) skew(1deg);
			opacity: .1
		}

		30% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .5
		}

		100% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .1
		}
	}

	@-o-keyframes coccoc-alo-circle-anim {
		0% {
			transform: rotate(0) scale(.5) skew(1deg);
			opacity: .1
		}

		30% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .5
		}

		100% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .1
		}
	}

	@keyframes coccoc-alo-circle-anim {
		0% {
			transform: rotate(0) scale(.5) skew(1deg);
			opacity: .1
		}

		30% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .5
		}

		100% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .1
		}
	}

	@-moz-keyframes coccoc-alo-circle-fill-anim {
		0% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}

		50% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .2
		}

		100% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}
	}

	@-webkit-keyframes coccoc-alo-circle-fill-anim {
		0% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}

		50% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .2
		}

		100% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}
	}

	@-o-keyframes coccoc-alo-circle-fill-anim {
		0% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}

		50% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .2
		}

		100% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}
	}

	@keyframes coccoc-alo-circle-fill-anim {
		0% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}

		50% {
			transform: rotate(0) scale(1) skew(1deg);
			opacity: .2
		}

		100% {
			transform: rotate(0) scale(.7) skew(1deg);
			opacity: .2
		}
	}


	.voice-box {
		width: 60px;
		height: 60px;
		margin: 50px auto;
		border-radius: 50%;
		background-color: var(--color);
		display: table;
		vertical-align: middle;
		cursor: pointer;
	}

	.voice-box.voice-box-trash {
		background-color: #cdcdcd
	}

	.voice-box.voice-box-trash:hover {
		background-color: #9e9a9a
	}

	.voice-box i {
		display: table-cell;
		vertical-align: middle;
		color: #fff;
		font-size: 1.5em;
	}

	.voice-box.voice-box-trash i {
		color: #333;
	}

	.microphone-content .content {
		position: absolute;
		z-index: 99;
		width: 100%;
		text-align: center;
		top: 85%;
	}

	.menu_resolve {
		padding: 5px 11px !important;
		margin-top: -5px;
		border-radius: 4px;
	}

	.menu_resolve:hover {
		background-color: hsla(0, 0%, 100%, .3);
	}

	.microphone.open {
		color: var(--borderColor);
	}

	svg.light-start {
		fill: #FDBF00;
	}

	.sendchat_button {
		background-color: var(--borderColor);
		border: 1px solid var(--borderColor);
	}

	.loadding_input {
		color: var(--borderColor);
		position: absolute;
		z-index: 99;
		left: 35%;
		top: 35%;
	}

	.sendchat_button svg {
		fill: #fff !important;
	}

	.sendchat_button:hover {
		background-color: #fff;
		;
	}

	.sendchat_button:hover svg {
		fill: var(--borderColor) !important;
	}

	.chat-input textarea::-webkit-input-placeholder {
		font-style: italic;
	}

	.chat-input textarea::-moz-placeholder {
		font-style: italic;
	}

	.chat-input textarea::-moz-placeholder {
		font-style: italic;
	}

	.chat-input textarea::-ms-input-placeholder {
		font-style: italic;
	}

	.chat-input textarea:focus::placeholder,
	.chat-input textarea.voice_open::-webkit-input-placeholder,
	.chat-input textarea.voice_open::-moz-placeholder,
	.chat-input textarea.voice_open::-ms-input-placeholder,
	.chat-input textarea.voice_open::placeholder {
		color: transparent;
	}

	/*end color button send */
	.slick-dots li {
		position: relative;
		display: inline-block;
		width: 10px;
		height: 10px;
		margin: 0 3px;
		padding: 0;
		cursor: pointer;
	}

	.slick-dots li button {
		font-size: 0;
		line-height: 0;
		display: block;
		width: 10px;
		height: 10px;
		padding: 5px;
		cursor: pointer;
		color: transparent;
		border-radius: 50%;
		border: 0;
		outline: none;
		background: #D9D9D9;
	}

	.slick-dots li.slick-active button,
	.slick-dots li button:hover {
		background-color: var(--borderColor);
	}

	.h-header .h-header-top {
		display: table;
	}

	.h-header .h-header-top .h-header-top-out {
		display: table-cell;
		vertical-align: middle;
		padding-left: 5px;
	}

	.h-header .h-header-top .h-header-top-out .head-action {
		position: absolute;
		z-index: 9;
		right: 0;
		top: 3px;
	}

	.slider .button {
		background: #e4e6eb;
		color: #fff;
		border: 0 none;
		border-radius: 20px;
		cursor: pointer;
		font-weight: bold;
		padding: 9px;
		text-transform: inherit;
		width: 80%;
		font-size: .9375rem;
		display: block;
		margin: 8px auto;
		opacity: .8;
	}

	/* css buttom rating */
	.slider .slide--feedback .button {
		border: 1px solid var(--borderColor);
		color: #ffff;
		background-color: var(--color);
	}

	.slider .slide--feedback .button:hover {
		color: var(--color);
		background-color: #ffff;
	}

	/* css buttom chat */
	.slider .button {
		border: 1px solid var(--borderColor);
		color: var(--color);
		background-color: #fff;
	}

	.slider .button:hover {
		background-color: var(--borderColor);
		color: var(--colorHover);
	}

	.chat-content-w .chat-message .reply {
		border-color: var(--borderColor);
		color: var(--color);
	}

	.chat-content-w .chat-message .reply:hover {
		background-color: var(--borderColor);
		color: var(--colorHover);
		border: 1px solid var(--borderColor);
	}

	.chat-content-w .chat-message .reply.active {
		background-color: var(--color);
		color: var(--colorHover);
	}

	.chat-content-w .chat-message .reply.active:hover {
		color: #ddd;
	}

	.h-header .logo {
		width: 60px;
		position: relative;
		margin: 0;

	}

	.h-header .logo img {
		border-radius: 50%;
		box-shadow: 0px 0px 4px #cdcdcd;
		width: 100%
	}

	.h-header .h-header-top {
		width: calc(100% - 60px);
		position: relative;
		float: left;
		margin-left: 5px;
		margin-top: 5px;
	}

	.h-header .logo img {
		width: 60px !important;
		height: 60px !important;
	}

	#greenBar {
		position: initial;
	}

	#greenBar i {
		position: absolute;
		z-index: 99;
		right: 1px;
		top: 1px;
		font-size: 1.5em;
		color: #0ce6e7;
	}

	.file_pdf_progress .video-icon .title>div {
		position: relative;
	}

	.video-icon img,
	.video-icon .img {
		position: relative;
		width: 42px;
		float: left;
	}

	.video-icon .img {
		display: table;
		text-align: center;
	}

	.video-icon .img span {
		display: table-cell;
		vertical-align: middle;
		text-transform: uppercase;
		text-align: center;
		color: #fff;
		font-weight: bold;
	}

	.video-icon .title {
		position: relative;
		width: calc(100% - 42px);
		float: left;
		text-align: left;
		padding: 0px 0 0 5px
	}

	.video-icon .title>div>span {
		font-size: .7rem;
		font-weight: 500;
		font-style: italic;
	}
	.chat-content-w .chat-message{overflow: hidden;}
	.chat-message.chat-message-main .chat-message-content-w {
		position: relative;
		word-break: break-word;
		/* overflow: hidden; */
	}

	.chat-message.chat-message-main .video_content,
	.chat-message.chat-message-main .file_pdf {
		float: left;
		background-color: #e5efff
	}

	.chat-message.chat-message-main .video_content video {
		border: 1px solid #f6f6f6;
		border-radius: 10px;
	}

	.chat-message.chat-message-main.self .video_content,
	.chat-message.chat-message-main.self .file_pdf {
		float: right;
		border-radius: 10px;
	}

	.chat-message.chat-message-main.self .file_pdf h5 {
		max-height: 32px;
		overflow: hidden;
	}


	.suggestions.PredictiveSuggestions__list__container {
		/*padding: 6px ​10px 0px 15px;*/
		/*padding: 10px;*/
		padding-top: 6px;
		padding-right: 10px;
		padding-bottom: 00px;
		padding-left: 15px;
		border-top: 1px solid rgb(232, 232, 235);
		/*transition: border-color 200ms ease-in 0s;*/
		position: relative;
	}

	.PredictiveSuggestions__suggestions-heading {
		text-align: left;
		display: inline-block;
		font-size: 13px;
		font-weight: 600;
		background: transparent;
		border: none;
		cursor: pointer;
		color: #484848;
	}

	/*.PredictiveSuggestions__icon {
    display: inline-block;
    background: transparent;
    border: none;
    padding: 0px;
    margin: 0px;
}



.PredictiveSuggestions__icon svg {
    pointer-events: all;
    cursor: pointer;
    opacity: 1;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    outline: none;
}
*/
	/*.PredictiveSuggestions__list__chevron--show {
    transform: rotate(0deg);
    transition: transform 0.3s ease-out;
}*/
	.PredictiveSuggestions__list__items--animate-in {
		opacity: 1;
		transition-delay: 0.2s;
		transition-delay: 0.5s;
		transition: opacity 0.75s ease-out;
	}

	.PredictiveSuggestions--animating-list-up {
		opacity: 1;
		transition-duration: 0.2s;
		transition-delay: 0.1s;
		transition-timing-function: ease-out;
	}

	.PredictiveSuggestions__list--desktop {
		margin-bottom: 12px;
	}

	.PredictiveSuggestions__list {
		margin: 0;
		padding: 0;
		list-style-type: none;
	}

	.PredictiveSuggestions__item {
		overflow: hidden;
		display: block;
		position: relative;
		text-align: left;
		border: none;
		font-size: 14px;
		padding: 0px;
		background: transparent;
		margin-right: 16px;
		height: 0px;
		opacity: 0px;
		cursor: pointer;
		height: 30px;
		opacity: 1;
		animation: flickerAnimation 0.5s infinite;
		color: rgb(240, 14, 14);
		animation-play-state: paused;
	}

	.PredictiveSuggestions__item:not(:hover) {
		text-decoration: none;
	}

	.PredictiveSuggestions__item:hover {
		text-decoration: underline;
	}

	.PredictiveSuggestions--collapsed {
		max-height: 36px;
	}

	.PredictiveSuggestions--collapsed ul.PredictiveSuggestions__list {
		/*display: none;*/
	}

	.PredictiveSuggestions--collapsed .PredictiveSuggestions__icon {
		transform: rotate(-180deg);
		transition: transform 0.2s ease-out;
	}

	.chat-message-main span.message {
		white-space: pre-line;
	}

	.mini-menu {
		z-index: 999;
		position: absolute;
		bottom: 43px;
		background: #fff;
		right: 72px;
	}

	.mini-menu ul li {
		position: relative;
		display: block;
		padding: 0.75rem 0.5rem;
		margin-bottom: -1px;
		background-color: #fff;
		border: 1px solid rgba(0, 0, 0, .125);
	}

	.mini-menu ul li:first-child {
		border-top-left-radius: 0.25rem;
		border-top-right-radius: 0.25rem;
	}

	.chat-controls {
		position: relative;
	}

	.mini-menu ul li:last-child {
		margin-bottom: 0;
		border-bottom-right-radius: 0.25rem;
		border-bottom-left-radius: 0.25rem;
	}

	.mini-menu ul li a {
		color: #2165ff;
		font-weight: 500;
	}

	/*hieu update*/
	.slide__next,
	.slide__prev,
	.slider:after,
	.slider:before {
		position: absolute;
		top: 5px;
		left: 5px;
		width: 25px;
		height: 25px;
		border: solid #000;
		border-width: 0 5px 5px 0;
		padding: 3px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}

	.template_list {
		margin: 5px;
	}

	.template_list .wrap-arrow {
		position: absolute;
		top: 43%;
		z-index: 99999;
		width: 25px;
		height: 37px;
		border: 1px solid transparent;
		border-radius: 50%;
		/* overflow: hidden; */
		background-color: transparent;
		cursor: pointer;
	}

	.template_list .wrap-arrow.wrap-arrow-prev {
		left: -15px;
	}

	.template_list .wrap-arrow.wrap-arrow-next {
		right: -1px;
	}

	.template_list .wrap-arrow .inner-arrow {
		position: relative;
		display: block;
	}

	/*end hieu update */

	.slider-container {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		overflow: hidden;
		padding: 0 4%;
	}

	.slider {
		width: 100%;
		/* height: 302px; */
		text-align: center;
		border-radius: 20px;
		overflow: hidden;
		position: relative;
	}

	.slides {
		display: flex;
		overflow-x: scroll;
		position: relative;
		scroll-behavior: smooth;
		scroll-snap-type: x mandatory;
		overflow: hidden;
		padding: 0 1px;
	}

	/* .slide:nth-of-type(even) {
  background-color: rgb(250, 246, 212);
} */

	.slide {
		/*display: flex;*/
		justify-content: center;
		align-items: center;
		flex-shrink: 0;
		width: 100%;
		height: 400px;
		scroll-snap-align: center;
		margin-right: 0px;
		box-sizing: border-box;
		background: white;
		transform-origin: center center;
		transform: scale(1);
	}

	.slide.slide--feedback {
		height: 100%;
	}

	.slide__text {
		font-size: 40px;
		/*font-weight: bold;*/
		/* font-family: sans-serif; */
		height: 100%
	}

	.slide a {
		background: none;
		border: none;
	}

	a.slide__prev,
	.slider::before {
		transform: rotate(135deg);
		-webkit-transform: rotate(135deg);
		left: 30%;
	}

	a.slide__next,
	.slider::after {
		transform: rotate(-45deg);
		-webkit-transform: rotate(-45deg);
		right: 35%;
	}

	.slider img {
		display: block;
		width: 100%;
		height: 179px;
		/*border-radius: 20px 20px 0 0;*/
		object-fit: cover;
	}

	.slider .detail {
		background: rgb(240, 240, 240);
		/*border-radius: 0px 0px 20px 20px;*/
		padding: 10px 15px;
		height: calc(100% - 179px);
		position: relative;
		margin-top: 2%;
		margin-bottom: 3%;
	}

	.slider .detail::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;

	}

	.slider .title {
		font-size: 1.0375rem;
		font-weight: bold;
		text-align: left;
		color: #050505;
		margin-bottom: 5px;
		text-align: center;
	}

	.slider .des {
		text-align: center;
		color: #65676B;
		font-size: .8125rem;
		line-height: 1.4em;
	}



	.slides>div {
		margin-right: 1px;
		/* scroll-snap-align: start;
  flex-shrink: 0;
  transform-origin: center center;
  transform: scale(1);
  transition: transform 0.5s; */
	}

	/* .slide:not(.current_slide) {
  display: none;
}
.slide.current_slide{
  transition: 1s;
  left: 0;
} */

	.table-content-list {
		list-style: none;
	}

	.table-content-list li {
		padding: 5px
	}

	.table-content-list li {
		padding: 5px
	}

	.table-content-list li .item {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		margin-bottom: 10px;
	}

	.table-content-list li .item span:first-child {
		width: 116px;
		margin-right: 6px;
	}

	.table-content-list li .item span {
		display: block;
		font-size: 1rem;
		line-height: 18px;
		word-break: break-word;
	}

	.table-content-list li .item span {
		color: #394E60;
	}

	.table-content-list li .item span:nth-child(2) {
		display: inline-block;
	}

	.slide__text--ticket {
		margin: 10px;
	}

	.slider--ticket {
		text-align: unset;
	}

	.detail--ticket {
		background-color: unset !important;
	}

	.text-center {
		text-align: center;
	}

	h6 {
		font-size: 1rem;
		font-weight: 400;
	}

	.slide__text--ticket__title {
		font-weight: 700;
		font-size: 1rem;
		line-height: 24px;
		padding: 0;
		margin-bottom: 6px;
	}

	.slide__text--ticket__subtitle {
		display: block;
		font-size: 0.875rem;
		margin-bottom: 12px;
		line-height: 20px;
	}

	.slider--ticket .slide {
		border-radius: 8px;
		background-color: #f9f7f7;
		height: 450px;
	}

	.button-disabled {
		color: #a7b3bf
	}

	.rating {
		display: inline-block;
		flex-direction: column;
		align-items: center;
		color: #b7b7b7;
		border-radius: 8px;
	}

	.rating .list {
		padding: 0;
		margin: 0;
		width: unset;
	}

	.rating .list .star {
		display: inline-block;
		font-size: 20px;
		transition: all .2s ease-in-out;
		cursor: pointer;
	}

	.rating .list .star.active {
		color: #ffe100;
	}

	.rating .list .star:first-child {
		margin-left: 0;
	}

	.mt-1 {
		margin-top: 1rem;
	}

	.modal-wrapper {
		position: fixed;
		top: 34px;
		right: 15px;
		bottom: 20px;
		left: 25px;
		background: rgba(0, 0, 0, 0.8);
		z-index: -1;
		opacity: 0;
		-webkit-transition: opacity 0.2s ease-in;
		-moz-transition: opacity 0.2s ease-in;
		transition: opacity 0.2s ease-in;
		pointer-events: auto;
		border-radius: 17px;
	}

	.modal-wrapper>div {
		width: 90%;
		height: 15%;
		position: absolute;

		top: 0;
		bottom: 0;
		left: 0;
		right: 0;

		margin: auto;

		vertical-align: middle;
		padding: 20px;
		border-radius: 6px;
		border: rgb(22, 136, 197) solid 1px;
		background: #fff;
		z-index: 1;
		text-align: center;
	}

	.close {
		background: rgb(22, 136, 197);
		color: #ffffff;
		line-height: 25px;
		position: absolute;
		right: -12px;
		text-align: center;
		top: -10px;
		width: 24px;
		text-decoration: none;
		font-weight: bold;
		-webkit-border-radius: 12px;
		-moz-border-radius: 12px;
		border-radius: 12px;
	}

	.close:hover {
		background: rgb(22, 136, 197);
	}

	#modal-phonenumber .modal {
		text-align: initial;
		padding: 0;
		height: 20%;
	}

	#modal-phonenumber .modal-header {
		text-align: initial;
		padding: 15px;
		border-bottom: solid 1px #1688c5;
	}

	#modal-phonenumber .modal-content {
		text-align: initial;
		padding: 15px;
	}

	#dropdown-shortcode,
	#dropdown-images {
		width: 100%;
		margin: 10px -10px 0;
		position: absolute;
	}

	.dropdown-menu {
		top: auto;
		bottom: 100%;
		margin-bottom: 1px;
	}

	.open>.dropdown-menu {
		display: block;
	}

	.dropdown-quickchat ul {
		max-height: 50vh;
		overflow: auto;
	}

	.dropdown-quickchat ul li.active {
		background-color: rgb(204, 215, 228);
	}

	.dropdown-quickchat ul li {
		cursor: pointer;
		padding: 10px;
		border-bottom: 1px solid rgb(204, 215, 228);
	}

	.list-suggestion-body,
	.list-image-body {
		border-radius: 15px;
	}

	.list-suggestion,
	.list-image {
		margin-left: 5px;
		background-color: #fff;
		border: 1px solid;
		border-radius: 15px
	}

	.suggestion-option:hover {
		background-color: var(--hover-color);
		color: #fff;
	}

	.image-sending .btn-closed {
        position: absolute;
        right: -4px;
        top: -7px;
        background: #efe8e8;
        border-radius: 50%;
        padding: 3px 5px;
        /* color: #1E68C6; */
        cursor: pointer;
        visibility: visible;
        opacity: 0;
        transition: visibility 0s, opacity 0.5s linear;
    }

    .image-sending:hover>.btn-closed {
        visibility: visible;
        opacity: 1;
    }

	.list-image-body{
		max-height: 50vh;
    	overflow: auto;
	}
</style>